<template>
  <div class="model-type-card">
    <v-container fluid style="padding: 0 15px;">
      <div style="display: flex; align-items: center;">
        <div style="display: flex; align-items: center;gap: 18px;">
          <label style="font-size: 20px; font-weight: 600;font-size: 30px;">
            <v-icon left size="30">
              {{ localEditAction ? "mdi-pencil" : "mdi-plus" }}
            </v-icon>
            {{
              page == "view model"
                ? "View Model"
                : localEditAction != null
                  ? localEditAction
                    ? "Update Model"
                    : "Create Model"
                  : "Create Model"
            }}
          </label>
          <v-chip id="modelID-modelmanagement" v-if="LLmsModel.modelDisplay"
            :color="LLmsModel.typeLLM === 1 ? '#4CAF50' : '#1976D2'" class="model-chip ml-2" outlined>
            <span class="model-id">Model ID: {{ LLmsModel.modelDisplay }}</span>
          </v-chip>
        </div>

        <div class="publication-header-wrapper">
          <div class="publication-header-controls">
            <v-chip class="publication-status-chip" :color="LLmsModel.isPublish ? '#2ABF56' : '#C1C3CB'"
              variant="elevated" size="45" pill>
              <span class="text-capitalize" style="color: #FFFFFF !important;">
                {{ LLmsModel.isPublish ? 'Published' : 'Draft' }}
              </span>
            </v-chip>

            <span class="publication-label">Publication Control</span>

            <v-switch id="publication-header-switch" v-model="LLmsModel.isPublish" hide-details inset
              density="comfortable" :class="[
                'publication-toggle',
                LLmsModel.isPublish
                  ? 'publication-toggle--active'
                  : 'publication-toggle--inactive'
              ]"></v-switch>

            <span class="publication-version text-capitalize">Version {{ LLmsModel.versioning || '1' }}</span>
          </div>
        </div>
      </div>
      <v-divider style="margin-top: 20px; margin-bottom: 25px"></v-divider>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-row>
              <v-container fluid>
                <v-row>
                  <!-- Model Type & Name Card -->
                  <v-col cols="12">
                    <v-row class="model-input-group">
                      <v-col cols="8">
                        <v-row>
                          <!-- Model Name -->
                          <v-col cols="4" class="model-input-col">
                            <span>Model Name <span style="color: red;">*</span> </span>
                            <v-text-field id="modelname-field-modelmanagement" v-model="LLmsModel.modelName"
                              :rules="[rules.required]" required density="compact" variant="outlined"
                              placeholder="Model Name" persistent-hint class="model-input-control">
                            </v-text-field>
                          </v-col>

                          <!-- Provider -->
                          <v-col cols="4" class="model-input-col">
                            <span>Provider <span style="color: red;">*</span> </span>
                            <v-autocomplete id="provider-autocomplete-modelmanagement" v-model="LLmsModel.provider"
                              :items="listDDProvider" item-title="providerName" item-value="providerName"
                              :rules="[rules.required]" placeholder="Provider"
                              required density="compact" variant="outlined" @update:model-value="
                                changeProvider(LLmsModel.provider),
                                clearLLM()
                                " persistent-hint class="model-input-control"
                            >
                              <template v-slot:item="{ props, item, index }">
                                <v-list-item 
                                  v-bind="props"
                                  :id="'provider-gptmodeldetail-option-' + index" 
                                  :value="item.raw.providerName"
                                >
                                  <template v-slot:title>
                                    <span>{{ item.raw.providerName }}</span>
                                  </template>
                                </v-list-item>
                              </template> 
                            </v-autocomplete>
                          </v-col>

                          <!-- Model -->
                          <v-col cols="4" class="model-input-col">
                            <span>Model <span style="color: red;">*</span> </span>
                            <v-autocomplete id="model-autocomplete-modelmanagement" v-model="LLmsModel.model"
                              :items="DDModelShow" item-title="modelDisplay" item-value="modelName" :rules="[
                                rules.required,
                                value => !value || value.split('')[0] !== '|' ? true : 'Please select model'
                              ]" required density="compact" variant="outlined" placeholder="Model"
                              @update:model-value="changeModel(LLmsModel.model)"
                              :disabled="!LLmsModel.provider" persistent-hint
                              class="model-input-control"
                            >
                              <template v-slot:item="{ props, item, index }">
                                <v-list-item 
                                  v-bind="props"
                                  :id="'model-gptmodeldetail-option-' + index" 
                                  :value="item.raw.modelName"
                                >
                                  <template v-slot:title>
                                    <span>{{ item.raw.modelDisplay }}</span>
                                  </template>
                                </v-list-item>
                              </template>
                            </v-autocomplete>
                          </v-col>
                        </v-row>
                      </v-col>

                      <!-- Model Type and model name-->
                      <v-col cols="4">
                        <v-row>
                          <div class="flexAllCenter mx-8">
                            <div class="custom-vertical-divider"></div>
                          </div>
                          <!-- Model Type -->
                          <div
                            style="display: flex;flex-direction: column;justify-content: flex-start !important; width: 80%;">
                            <span>Model Type <span style="color: red;">*</span> </span>
                            <div class="model-type-toggle-container">
                              <v-btn-toggle v-model="LLmsModel.typeLLM" class="model-type-toggle" density="compact">
                                <v-btn id="button-bot-modelmanagement" :value="0" class="model-type-btn"
                                  :disabled="localEditAction"><span style="font-weight: 600;font-size: 16px;">Bot</span></v-btn>
                                <v-btn id="button-guardrail-modelmanagement" :value="1" class="model-type-btn"
                                  :disabled="localEditAction"><span style="font-weight: 600;font-size: 16px;">Guard Rail</span></v-btn>
                              </v-btn-toggle>
                            </div>
                          </div>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row>
                      <!-- Description - Full Width -->
                      <v-col cols="12" class="mt-3" style="display: flex;flex-direction: column;">
                        <span>Description</span>
                        <v-textarea id="description-textarea-modelmanagement" v-model="LLmsModel.description"
                          density="compact" variant="outlined" auto-grow rows="1"
                          placeholder="Brief description of what this model does" persistent-hint
                          class="description-field"></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <transition name="fade">
                        <div v-if="txtToImgChecker" class="image-settings-container mb-4" style="width: 100%">
                          <!-- Enhanced Header -->
                          <v-card variant="outlined" class="image-settings-card">
                            <v-card-title class="image-header d-flex align-center py-4">
                              <v-icon color="blue-grey darken-2 mr-5" size="28">mdi-image-edit</v-icon>
                              <div class="flex-grow-1">
                                <h3 class="text-h6 mb-1">Image Generation Settings</h3>
                                <p class="text-caption text-grey-darken-1 mb-0">Configure AI image generation parameters</p>
                              </div>
                            </v-card-title>

                            <v-divider></v-divider>

                            <!-- Enhanced Content -->
                            <v-card-text class="pa-6">
                              <v-row class="image-settings-row">
                                <!-- Style Selection -->
                                <v-col cols="12" md="6">
                                  <div class="setting-group">
                                    <div class="setting-label mb-3">
                                      <v-icon color="indigo" size="small" class="mr-2">mdi-palette</v-icon>
                                      <span class="font-weight-medium">Image Style</span>
                                      <v-chip size="x-small" color="red" class="ml-2">Required</v-chip>
                                    </div>

                                    <v-select id="imagestyle-select-modelmanagement" v-model="LLmsModel.styleImage"
                                      :items="imageStyleOptions" item-title="text" item-value="value" :rules="[rules.required]"
                                      variant="outlined" density="compact" required class="enhanced-select style-select"
                                      placeholder="Choose image style" prepend-inner-icon="mdi-brush">
                                      <template v-slot:selection="{ item }">
                                        <div class="d-flex align-center">
                                          <v-icon :color="item.raw.value === 'natural' ? 'green' : 'orange'" size="small"
                                            class="mr-2">
                                            {{ item.raw.value === 'natural' ? 'mdi-leaf' : 'mdi-creation' }}
                                          </v-icon>
                                          <span class="font-weight-medium">{{ item.raw.text }}</span>
                                        </div>
                                      </template>

                                      <template v-slot:item="{ props, item }">
                                        <v-list-item v-bind="props" class="style-item">
                                          <template v-slot:prepend>
                                            <v-avatar
                                              :color="item.raw.value === 'natural' ? 'green lighten-4' : 'orange lighten-4'"
                                              size="32">
                                              <v-icon size="16" color="white">
                                                {{ item.raw.value === 'natural' ? 'mdi-leaf' : 'mdi-creation' }}
                                              </v-icon>
                                            </v-avatar>
                                          </template>
                                          <template v-slot:title>
                                            <span class="font-weight-medium">{{ item.raw.text }}</span>
                                          </template>
                                          <template v-slot:subtitle>
                                            <span class="text-caption">
                                              {{ item.raw.value === 'natural' 
                                              ? 'Realistic and natural looking' : 
                                              'Vibrant and dramatic style' }}
                                            </span>
                                          </template>
                                        </v-list-item>
                                      </template>
                                    </v-select>

                                    <div>
                                      <v-icon size="small" color="grey-darken-1" class="mr-1">mdi-information-outline</v-icon>
                                      <span class="text-caption text-grey-darken-1">Choose the artistic style for generated
                                        images</span>
                                    </div>
                                  </div>
                                </v-col>

                                <!-- Quality Setting -->
                                <v-col cols="12" md="3">
                                  <div class="setting-group">
                                    <div class="setting-label mb-3">
                                      <v-icon color="blue" size="small" class="mr-2">mdi-quality-high</v-icon>
                                      <span class="font-weight-medium">Quality</span>
                                    </div>

                                    <v-text-field label="Quality Level" variant="outlined" density="compact" disabled
                                      v-model="LLmsModel.quality" prepend-inner-icon="mdi-diamond-stone" class="quality-field"
                                      readonly>
                                      <template v-slot:append-inner>
                                        <v-icon size="small" color="grey" v-bind="props">
                                          mdi-lock
                                        </v-icon>
                                      </template>
                                    </v-text-field>
                                  </div>
                                </v-col>

                                <!-- Resolution Setting -->
                                <v-col cols="12" md="3">
                                  <div class="setting-group">
                                    <div class="setting-label mb-3">
                                      <v-icon color="indigo" size="small" class="mr-2">mdi-monitor-screenshot</v-icon>
                                      <span class="font-weight-medium">Resolution</span>
                                    </div>

                                    <v-text-field label="Image Size" variant="outlined" density="compact" disabled
                                      v-model="LLmsModel.resolution" value="1024x1024" prepend-inner-icon="mdi-aspect-ratio"
                                      class="resolution-field" readonly>
                                      <template v-slot:append-inner>
                                        <v-icon size="small" color="grey" v-bind="props">
                                          mdi-lock
                                        </v-icon>
                                      </template>
                                    </v-text-field>

                                    <div>
                                      <v-icon size="small" color="grey-darken-1" class="mr-1">mdi-information-outline</v-icon>
                                      <span class="text-caption text-grey-darken-1">Image resolution in pixels</span>
                                    </div>
                                  </div>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </div>
                      </transition>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="8">
                    <!-- Header with info and action buttons -->
                    <div class="d-flex align-center justify-space-between mb-4">
                      <h3 class="text-subtitle-1" style="font-weight: 600; display: flex; align-items: center;">
                        <Icon class="me-2" icon="lucide:pen-line" style="font-size: 22px;color: #8D8D8D;" />
                        Set System Prompt for Your Model
                      </h3>
                    </div>
                        <v-card variant="outlined" class="prompt-editor-card">
                          <v-card-text class="px-2 py-1">
                            <v-textarea id="PromptTemplate" :label="''" variant="plain" counter auto-grow rows="8"
                              v-model="LLmsModel.promptTemplate" :rules="[
                                validatePrompt(LLmsModel.promptTemplate),
                              ]" required placeholder="Enter your system prompt here..."
                              class="prompt-textarea"></v-textarea>
                          </v-card-text>
                        </v-card>
                  </v-col>

                  <v-col cols="4">
                    <v-card class="prompt-templates-card h-100">
                      <v-card-title class="py-3 px-4 d-flex align-center">
                        <span class="text-subtitle-2" style="font-weight: 700;">Prompt Template</span>
                        <div class="d-flex align-center ml-2">
                          <v-tooltip location="top">
                            <template v-slot:activator="{ props }">
                              <v-icon icon="mdi-information-outline" size="20" color="#A6A6A6" class="me-3"
                                v-bind="props">mdi-information-outline</v-icon>
                            </template>
                            <span>Select a prompt template to replace the current prompt.</span>
                          </v-tooltip>
                        </div>
                      </v-card-title>

                      <div class="px-3 pt-3">
                        <v-autocomplete class="mb-3 rounded-input padding-input" id="groupprompttemplate-autocomplete-modelmanagement"
                          :items="DDGroupPromptTemplate" item-title="name" placeholder="Select Prompt Template"
                          item-value="id" density="compact" clearable variant="outlined" v-model="groupPromptTemplate"
                          hide-details style="background-color: white; border-radius: 8px;"
                        >
                          <template v-slot:item="{ props, item, index }">
                            <v-list-item 
                              v-bind="props"
                              :id="'groupprompttemplate-gptmodeldetail-option-' + index" 
                              :value="item.raw.name"
                            >
                              <template v-slot:title>
                                <span>{{ item.raw.name }}</span>
                              </template>
                            </v-list-item>
                          </template>
                        </v-autocomplete>
                      </div>

                      <!-- <v-divider class="mt-2"></v-divider> -->

                      <v-list class="prompt-template-list" density="compact">

                        <div v-if="filteredPromptTemplates.length === 0" class="pa-4 text-center text-grey-darken-1 h-100 mt-9">
                          <Icon class="d-block mx-auto mb-2" icon="fluent:book-template-20-filled" style="font-size: 22px;color: #8D8D8D;" />
                          <span>No templates available</span>
                        </div>

                        <template v-else>
                          <v-list-item v-for="(item, i) in filteredPromptTemplates.slice(0, 10)" :key="i"
                            @click="SetSelectPromptTemplate(item)" :ripple="true" class="template-list-item">
                            <template v-slot:prepend>
                              <v-icon icon="mdi-text-box-outline" size="small"></v-icon>
                            </template>
                            <template v-slot:title>
                              <span id="list-nameprompttemplate-modelmanagement" class="text-body-2">{{ item.name
                              }}</span>
                            </template>
                            <template v-slot:append>
                              <v-icon size="small" color="primary">mdi-plus-circle-outline</v-icon>
                            </template>
                          </v-list-item>

                          <div v-if="filteredPromptTemplates.length > 10" class="d-flex justify-center py-2">
                            <v-btn id="button-showallprompttemplate-modelmanagement" variant="text" color="primary"
                              size="small" density="comfortable" @click="showAll"
                              prepend-icon="mdi-format-list-bulleted">
                              {{ $t("_ShowAll") }} ({{
                                filteredPromptTemplates.length
                              }})
                            </v-btn>
                          </div>
                        </template>
                      </v-list>
                    </v-card>
                    <!-- Context menu for prompt templates -->
                    <v-menu v-model="showMenu" :activator="{ x, y }" location="bottom">
                      <v-card min-width="250" elevation="3">
                        <v-list density="compact" class="py-0">
                          <v-list-subheader class="d-flex bg-grey-lighten-4 py-2">
                            <v-icon icon="mdi-text-box-plus-outline" class="me-2" size="small"></v-icon>
                            Insert Template
                          </v-list-subheader>
                          <v-divider :thickness="1" class="border-opacity-100"></v-divider>
                          <v-list-item v-for="(item, index) in filteredPromptTemplates" :key="index" @click="
                            SetSelectPromptTemplate(item);
                          showMenu = false;
                          " :value="item.name" class="template-list-item">
                            <template v-slot:prepend>
                              <v-icon size="small" icon="mdi-text-box-outline"></v-icon>
                            </template>
                            <template v-slot:title>
                              <span>{{ item.name }}</span>
                            </template>
                          </v-list-item>
                        </v-list>
                      </v-card>
                    </v-menu>
                  </v-col>

                  <!-- Dialog for showing all templates -->
                  <v-dialog v-model="dialogShowAll" max-width="550" scrollable>
                    <v-card>
                      <v-card-title class="bg-primary text-white d-flex align-center">
                        <v-icon icon="mdi-text-box-multiple-outline" class="me-2"></v-icon>
                        Prompt Templates
                      </v-card-title>
                      <v-divider :thickness="1" class="border-opacity-100"></v-divider>
                      <v-card-text style="max-height: 500px" class="pt-4">
                        <v-text-field v-model="templateSearchQuery" label="Search templates"
                          prepend-inner-icon="mdi-magnify" variant="outlined" density="compact" hide-details
                          class="mb-3" clearable></v-text-field>

                        <v-list density="compact" class="template-list-all pa-0">
                          <v-list-item v-for="(item, i) in searchedTemplates" :key="i"
                            @click="SetSelectPromptTemplate(item)" class="template-list-item" :ripple="true">
                            <template v-slot:prepend>
                              <v-icon size="small" color="primary" icon="mdi-text-box-outline"></v-icon>
                            </template>
                            <template v-slot:title>
                              <span id="list-nameprompttemplateall-modelmanagement">{{ item.name }}</span>
                            </template>
                            <template v-slot:subtitle>
                              <span class="text-caption text-truncate">{{
                                truncatePrompt(item.prompt)
                              }}</span>
                            </template>
                          </v-list-item>
                        </v-list>
                      </v-card-text>
                      <v-divider :thickness="1" class="border-opacity-100"></v-divider>
                      <v-card-actions class="pa-3 bg-grey-lighten-4">
                        <v-spacer></v-spacer>
                        <v-btn id="button-close-popupshowall-modelmanagement" color="primary" variant="text"
                          @click="dialogShowAll = false">
                          {{ $t("close") }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-row>

                <!-- Extension Configuration -->
                <!-- <v-card class="mb-1" variant="outlined">
                  <v-row style="margin: 10px 0px" no-gutters>
                    <v-col sm="2" class="d-flex align-center font-weight-bold" style="white-space: nowrap">
                      Model Configuration
                    </v-col>
                    <v-col sm="10" class="d-flex align-center">
                      <v-divider :thickness="1" class="border-opacity-90"></v-divider>
                    </v-col>
                  </v-row>
                  <v-card-text>
                    <v-row density="compact">

                      <v-col cols="12" md="4">
                        <v-text-field id="model-extension-modelmanagement" v-model="LLmsModel.extension"
                          label="Extension" density="compact" variant="outlined" prepend-inner-icon="mdi-puzzle-outline"
                          hint="Optional model extension" persistent-hint></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card> -->

              </v-container>
            </v-row>
            
            <!-- Knowledge -->
            <v-expansion-panels class="modern-panels" style="margin-top: 36px;" :elevation="3">
              <v-expansion-panel>
                <template v-slot:title>
                  <div class="d-flex align-center panel-header py-2" style="padding-left: 22px;">
                    <Icon icon="basil:book-solid" style="font-size: 22px;color: #C32E0E" />
                    <span class="header">Knowledge</span>
                  </div>
                </template>
                <template v-slot:text>
                  <v-row style="margin: 5px 0px; border-top: 1px solid #e5e7eb;margin-top: -22px;padding-top: 20px;">
                    <Icon icon="f7:doc-text-fill" style="font-size: 22px;color: #C32E0E;" />
                    <span class="ml-2" style="font-weight: 500;">Documents</span>
                  </v-row>
                  <v-row style="margin-bottom: 25px">
                    <v-col cols="4" class="col-label-input">
                      <span>Document Name</span>
                      <v-autocomplete class="rounded-input padding-input" id="documentname-autocomplete-modelmanagement" :placeholder="'Document Name'"
                        :items="DDVector" item-title="name" item-value="name" density="compact" chips deletable-chips
                        multiple clearable variant="outlined" v-model="LLmsModel.vectordbName" :rules="[rules.required]">
                        <template v-slot:item="{ props, item, index }">
                          <v-list-item 
                            v-bind="props"
                            :id="'documentname-gptmodeldetail-option-' + index" 
                            :value="item.raw.name"
                          >
                            <template v-slot:title>
                              <span>{{ item.raw.name }}</span>
                            </template>
                          </v-list-item>
                        </template>
                        <template v-slot:append-outer>
                          <v-tooltip location="top" max-width="300">
                            <template v-slot:activator="{ props }">
                              <v-icon id="infovectorDBname-modelmanagement" size="x-small" style="
                                    position: absolute;
                                    top: 0px;
                                    right: -6px;
                                  " v-bind="props">mdi-information-outline</v-icon>
                            </template>
                            <span>{{ $t("_InfoVectorDBName") }}</span>
                          </v-tooltip>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="4" class="col-label-input">
                      <span>Top-N Chunks</span>
                      <v-text-field class="rounded-input padding-input" id="top-n-chunks-field-modelmanagement" :placeholder="'Top-N Chunks'" density="compact"
                        :disabled="LLmsModel.vectordbName.length == 0" v-model="LLmsModel.topVDB" clearable
                        variant="outlined" @keypress="isNumberpositive($event)" :rules="[checkValidate()]">
                        <template v-slot:append-outer>
                          <v-tooltip location="top">
                            <template v-slot:activator="{ props }">
                              <v-icon id="infotopVDB-modelmanagement" text size="x-small" style="
                                    position: absolute;
                                    top: 0px;
                                    right: -6px;
                                  " v-bind="props">mdi-information-outline</v-icon>
                            </template>
                            <span>{{ $t("_InfoTopVDB") }}</span>
                          </v-tooltip>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="4" class="col-label-input">
                      <span>Text Replacement</span>
                      <v-autocomplete class="rounded-input padding-input" id="text-replacement-modelmanagement" :placeholder="'Text Replacement'"
                        :items="DDGroupReplace" item-title="name" density="compact" chips deletable-chips
                        item-value="id" multiple clearable variant="outlined" v-model="LLmsModel.groupReplaceID"
                        >
                        <template v-slot:item="{ props, item, index }">
                          <v-list-item 
                            v-bind="props"
                            :id="'textreplacement-gptmodeldetail-option-' + index" 
                            :value="item.raw.name"
                          >
                            <template v-slot:title>
                              <span>{{ item.raw.name }}</span>
                            </template>
                          </v-list-item>
                        </template>
                        <template v-slot:append-outer>
                          <v-tooltip location="top">
                            <template v-slot:activator="{ props }">
                              <v-icon id="InfoGroupReplaceText-modelmanegement" text size="x-small" style="
                                    position: absolute;
                                    top: 0px;
                                    right: -6px;
                                  " v-bind="props">mdi-information-outline</v-icon>
                            </template>
                            <span>{{ $t("_InfoGroupReplaceText") }}</span>
                          </v-tooltip>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  
                  <v-row style="margin: 5px 0px;margin-top: -20px;">
                    <v-icon color="#C32E0E">mdi-database</v-icon>
                    <span class="ml-2" style="font-weight: 500;">Database</span>
                  </v-row>
                  <v-row>
                    <v-col cols="4" class="col-label-input">
                      <span>Table Name</span>
                      <v-autocomplete class="rounded-input" id="tablename-autocomplete-modelmanagement" :label="'Table Name'"
                        :items="listDataIntegration" item-title="dataName" item-value="id" density="compact" clearable
                        variant="outlined" v-model="LLmsModel.DataIntegrationID" hide-details>
                        <template v-slot:item="{ props, item, index }">
                          <v-list-item 
                            v-bind="props"
                            :id="'tablename-gptmodeldetail-option-' + index" 
                            :value="item.raw.dataName"
                          >
                            <template v-slot:title>
                              <span>{{ item.raw.dataName }}</span>
                            </template>
                          </v-list-item>
                        </template>
                        <template v-slot:append-outer>
                          <v-tooltip location="top" max-width="300">
                            <template v-slot:activator="{ props }">
                              <v-icon text size="x-small" style="
                                    position: absolute;
                                    top: 0px;
                                    right: -6px;
                                  " v-bind="props">mdi-information-outline</v-icon>
                            </template>
                            <span>{{ $t("_InfoDataIntegration") }}</span>
                          </v-tooltip>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="4" class="col-label-input">
                      <span>SQL Extraction Model</span>
                      <v-autocomplete class="rounded-input" id="sqlextractionmodel-autocomplete-modelmanagement"
                        :label="'SQL Extraction Model'" :items="listSqlExtract" item-title="name"
                        item-value="modelDisplayID" density="compact" clearable variant="outlined"
                        v-model="LLmsModel.SqlModelID" hide-details>
                        <template v-slot:item="{ props, item, index }">
                          <v-list-item 
                            v-bind="props"
                            :id="'sqlextractionmodel-gptmodeldetail-option-' + index" 
                            :value="item.raw.name"
                          >
                            <template v-slot:title>
                              <span>{{ item.raw.name }}</span>
                            </template>
                          </v-list-item>
                        </template>
                        <template v-slot:append-outer>
                          <v-tooltip location="top" max-width="300">
                            <template v-slot:activator="{ props }">
                              <v-icon text size="x-small" style="
                                    position: absolute;
                                    top: 0px;
                                    right: -6px;
                                  " v-bind="props">mdi-information-outline</v-icon>
                            </template>
                            <span>{{ $t("_InfoSQLExtractStatement") }}</span>
                          </v-tooltip>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="4" class="col-label-input" style="align-items: flex-start;">
                      <span style="color: transparent; pointer-events: none; user-select: none; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none;" unselectable="on" aria-hidden="true">-</span>
                      <v-btn id="button-customize-nodata-modelmanagement" color="primary" variant="flat"
                        :prepend-icon="promptSqlNoDataButtonIcon" class="no-data-message-button" rounded="lg"
                        @click="openPromptSqlNoDataDialog">
                        {{promptSqlNoDataButtonText}}
                      </v-btn>
                    </v-col>
                  </v-row>

                    <v-dialog v-model="promptSqlNoDataDialog" max-width="600" persistent>
                    <v-card class="no-data-dialog-card" elevation="4">
                      <v-card-title class="d-flex align-center justify-space-between py-4 px-5">
                        <span class="text-h6 font-weight-bold">Customize No Data Message</span>
                        <v-btn id="button-close-nodata-dialog-modelmanagement" variant="text" icon="mdi-close"
                          color="grey-darken-1" @click="cancelPromptSqlNoDataDialog"></v-btn>
                      </v-card-title>
                      <v-card-text class="px-5 pt-0 pb-2">
                        <v-textarea id="promptsqlnodata-textarea-modelmanagement" variant="outlined" rows="7"
                          v-model="promptSqlNoDataDraft" placeholder="Enter the text to display when no data is found"
                          auto-grow></v-textarea>
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions class="py-4 px-5 justify-end">
                        <v-btn id="button-cancel-nodata-dialog-modelmanagement" class="dialog-close-btn mr-3" variant="text" color="grey-darken-1"
                          prepend-icon="mdi-close" @click="cancelPromptSqlNoDataDialog">Close</v-btn>
                        <v-btn id="button-save-nodata-dialog-modelmanagement" class="dialog-save-btn" color="primary" variant="flat"
                          prepend-icon="mdi-content-save" @click="savePromptSqlNoData">Save</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  
                  <v-row style="margin: 5px 0px;margin-top: 35px;">
                    <Icon icon="lets-icons:bag-fill" style="font-size: 22px;color: #C32E0E;" />
                    <span class="ml-2" style="font-weight: 500;">Products</span>
                  </v-row>
                  <v-row style="margin-bottom: 25px">
                    <v-col cols="4" class="col-label-input">
                      <span>Product Group Name</span>
                      <v-autocomplete class="rounded-input" :label="'Product Group Name'" :items="DDProductGroup" item-title="name"
                        density="compact" chips deletable-chips item-value="id" multiple clearable variant="outlined"
                        v-model="LLmsModel.productGroupID">
                        <template v-slot:item="{ props, item, index }">
                          <v-list-item 
                            v-bind="props"
                            :id="'productgroupname-gptmodeldetail-option-' + index" 
                            :value="item.raw.name"
                          >
                            <template v-slot:title>
                              <span>{{ item.raw.name }}</span>
                            </template>
                          </v-list-item>
                        </template>
                        <template v-slot:append-outer>
                          <v-tooltip location="top">
                            <template v-slot:activator="{ props }">
                              <v-icon text size="x-small" style="
                                    position: absolute;
                                    top: 0px;
                                    right: -6px;
                                  " v-bind="props">mdi-information-outline</v-icon>
                            </template>
                            <span>{{ $t("_InfoGroupReplaceText") }}</span>
                          </v-tooltip>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="4" class="col-label-input">
                      <span>Top-N Chunks</span>
                      <v-text-field class="rounded-input" id="top-n-chunks-field-modelmanagement" :label="'Top-N Chunks'" density="compact"
                        :disabled="LLmsModel.productGroupID.length == 0" v-model="LLmsModel.productTopVDB" clearable
                        variant="outlined" @keypress="isNumberpositive($event)" :rules="[checkProductValidate()]">
                        <template v-slot:append-outer>
                          <v-tooltip location="top">
                            <template v-slot:activator="{ props }">
                              <v-icon text size="x-small" style="
                                    position: absolute;
                                    top: 0px;
                                    right: -6px;
                                  " v-bind="props">mdi-information-outline</v-icon>
                            </template>
                            <span>{{ $t("_InfoTopVDB") }}</span>
                          </v-tooltip>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>
                </template>
              </v-expansion-panel>
            </v-expansion-panels>

            <!-- Workflow -->
            <v-expansion-panels class="modern-panels" :elevation="3" v-model="workflowPanelOpen">
              <v-expansion-panel>
                <template v-slot:title>
                  <div class="d-flex align-items-center justify-space-between w-100">
                    <div style="padding-left: 22px;">
                      <div class="d-flex align-center panel-header py-2 workflow-header">
                        <div class="workflow-header__icon">
                          <v-icon color="#C32E0E" size="20">mdi-sitemap</v-icon>
                        </div>
                        <div class="workflow-header__text">
                          <span class="header">Workflow</span>
                        </div>
                      </div>
                      <span class="workflow-header__subtitle" v-show="workflowPanelOpen === 0">Configure workflow integration for this model</span>
                    </div>
                    
                    <div class="chipdiv" v-show="workflowPanelOpen === 0" >
                      <div class="d-flex flex-column align-end">
                        <v-chip 
                        :class="{ 'flow-selected': LLmsModel.flowGroupID, 'flow-not-selected': !LLmsModel.flowGroupID }"
                        size="small"
                      >
                        <v-icon 
                          :color="LLmsModel.flowGroupID ? 'green' : 'white'" 
                          class="mr-2"
                          size="16"
                        >
                          {{ LLmsModel.flowGroupID ? 'mdi-check-circle' : 'mdi-close-circle' }}
                        </v-icon>
                        {{ LLmsModel.flowGroupID ? 'Flow Connected' : 'No Flow Selected' }}
                      </v-chip>
                      <span class="mt-2 chipspan">Select a flow enable workflow integration</span>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-slot:text>
                  
                  <v-row style="margin: 5px 0px; border-top: 1px solid #e5e7eb;margin-top: -22px;padding-top: 20px;"></v-row>
                  <v-row>
                    <v-col cols="4">
                      <div style="display: flex;flex-direction: column;">
                        <span class="mb-2"><v-icon class="mr-2">mdi-chart-timeline-variant-shimmer</v-icon>Flow Configuration</span>
                        <v-select id="flow-dropdown-modelmanagement" v-model="LLmsModel.flowGroupID"
                          :items="flowDropdown" item-title="name" item-value="flowGroupID"
                          density="comfortable" variant="outlined" clearable
                          class="flow-select-enhanced" placeholder="Select Flow">
                          <template v-slot:selection="{ item }">
                            <div>
                              <span class="font-weight-medium">{{ item.raw.name }}</span>
                            </div>
                          </template>

                          <template v-slot:item="{ props, item, index }">
                            <v-list-item 
                              v-bind="props" 
                              class="flow-list-item"
                              :id="'flow-gptmodeldetail-option-' + index"
                              :value="item.raw.flowGroupID">
                              <template v-slot:prepend>
                                <v-avatar size="32" color="primary" variant="tonal">
                                  <v-icon size="16" color="primary">mdi-chart-timeline-variant-shimmer</v-icon>
                                </v-avatar>
                              </template>
                              <template v-slot:title>
                                <span class="font-weight-medium">{{ item.raw.name }}</span>
                              </template>
                              <template v-slot:subtitle>
                                <span class="text-caption text-grey-darken-1">
                                  Flow ID: {{ item.raw.flowGroupID }}
                                </span>
                              </template>
                            </v-list-item>
                          </template>
                        </v-select>
                      </div>
                    </v-col>
                    <v-col cols="4">
                      <div style="display: flex;flex-direction: column;">
                        <span class="mb-2"><v-icon class="mr-2">mdi-target</v-icon>Intent Detection</span>
                        <v-autocomplete id="groupintent-autocomplete-modelmanagement" placeholder="Select Intent"
                          :items="listDDIntentGroup" item-title="name" item-value="id" density="compact" clearable
                          variant="outlined" class="flow-select-enhanced autocomplete-field-c" v-model="LLmsModel.IntentGroupID"
                          :disabled="intentAutocompleteDisabled" :hint="intentHelperText"
                          :persistent-hint="intentAutocompleteDisabled" hide-details="auto">
                          <template v-slot:item="{ props, item, index }">
                            <v-list-item 
                              v-bind="props"
                              :id="'groupintent-gptmodeldetail-option-' + index" 
                              :value="item.raw.name"
                            >
                              <template v-slot:title>
                                <span>{{ item.raw.name }}</span>
                              </template>
                            </v-list-item>
                          </template>
                          <template v-slot:append-outer>
                            <v-tooltip location="top" max-width="300">
                              <template v-slot:activator="{ props }">
                                <v-icon text size="x-small" style="
                                      position: absolute;
                                      top: 0px;
                                      right: -6px;
                                    " v-bind="props">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t("_InfoDataIntegration") }}</span>
                            </v-tooltip>
                          </template>
                        </v-autocomplete>
                      </div>
                    </v-col>
                    <v-col cols="4" v-if="LLmsModel.typeLLM == 0">
                      <div style="display: flex;flex-direction: column;">
                        <span class="mb-2"><v-icon class="mr-2">mdi-shield-outline</v-icon>Guard Rail</span>
                        <v-autocomplete id="guardrailmodel-autocomplete-modelmanagement" placeholder="Select Guard Rail"
                          :items="listGuardRailModel" item-title="name" item-value="modelDisplayID" density="compact"
                          clearable variant="outlined" class="flow-select-enhanced autocomplete-field-c"
                          v-model="LLmsModel.guardRailModelID" hide-details>
                          <template v-slot:item="{ props, item, index }">
                            <v-list-item 
                              v-bind="props" 
                              :id="'guardrail-gptmodeldetail-option-' + index" 
                              :value="item.raw.name"
                            >
                              <template v-slot:title>
                                <span>{{ item.raw.name }}</span>
                              </template>
                            </v-list-item>
                          </template>
                          <template v-slot:append-outer>
                            <v-tooltip location="top" max-width="300">
                              <template v-slot:activator="{ props }">
                                <v-icon text size="x-small" style="
                                      position: absolute;
                                      top: 0px;
                                      right: -6px;
                                    " v-bind="props">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t("_InfoSQLExtractStatement") }}</span>
                            </v-tooltip>
                          </template>
                        </v-autocomplete>
                      </div>
                    </v-col>
                  </v-row>
                </template>
              </v-expansion-panel>
            </v-expansion-panels>

            <!-- Model Setting -->
            <v-expansion-panels class="modern-panels" :elevation="3">
              <v-expansion-panel>
                <template v-slot:title>
                  <div class="d-flex align-center panel-header py-2" style="padding-left: 22px;">
                    <Icon icon="lets-icons:setting-alt-fill" style="font-size: 22px;color: #C32E0E" />
                    <span class="header">Model Setting</span>
                  </div>
                </template>
                <template v-slot:text>
                  <v-row style="margin: 5px 0px; border-top: 1px solid #e5e7eb;margin-top: -22px;padding-top: 20px;"></v-row>
                  <div class="memory-section-wrapper">
                    <v-row class="memory-card">
                      <v-col cols="8" style="height: 160px;">
                        <div class="memory-card__short">
                          <div class="memory-section-header">
                            <div class="memory-icon">
                              <Icon icon="fluent:brain-circuit-28-filled" style="font-size: 28px;color: #C32E0E" />
                            </div>
                            <div>
                              <h4 class="memory-title">Short-Term Memory</h4>
                            </div>
                          </div>
                          <v-row class="memory-input-row" dense>
                            <v-col cols="4" class="col-label-input">
                              <span>Turn</span>
                              <v-text-field id="turn-memory-modelmanagement" :placeholder="'Turn'" clearable
                                variant="outlined" density="comfortable" v-model="LLmsModel.historyCount"
                                class="rounded-input"
                                @keypress="isNumberpositive($event)" min="0" hide-details>
                                <template v-slot:append-outer>
                                  <v-tooltip location="top">
                                    <template v-slot:activator="{ props }">
                                      <v-icon text size="x-small" style="
                                            position: absolute;
                                            top: 0px;
                                            right: -6px;
                                          " v-bind="props">mdi-information-outline</v-icon>
                                    </template>
                                    <span>{{ $t("_InfoTurn") }} </span>
                                  </v-tooltip>
                                </template>
                              </v-text-field>
                            </v-col>
                            <v-col cols="4" class="col-label-input">
                              <span>Character/Turn</span>
                              <v-text-field id="short-term-memory-modelmanagement" :placeholder="'Character/Turn'" clearable
                                density="comfortable" class="rounded-input" variant="outlined" v-model="LLmsModel.Len_ShortMemory"
                                @keypress="numericKey" min="1" hide-details>
                                <template v-slot:append-outer>
                                  <v-tooltip location="top">
                                    <template v-slot:activator="{ props }">
                                      <v-icon text size="x-small" style="
                                            position: absolute;
                                            top: 0px;
                                            right: -6px;
                                          " v-bind="props">mdi-information-outline</v-icon>
                                    </template>
                                    <span>{{ $t("_InfoShortMemory") }}</span>
                                  </v-tooltip>
                                </template>
                              </v-text-field>
                            </v-col>
                            <v-col cols="4" class="col-label-input">
                              <span>Duration (Minute)</span>
                              <v-text-field id="duration-memory-modelmanagement" :placeholder="'Duration (Minute)'" clearable
                                variant="outlined" density="comfortable" class="rounded-input" v-model="LLmsModel.historyMinute"
                                @keypress="isNumber($event)" hide-details>
                                <template v-slot:append-outer>
                                  <v-tooltip location="top">
                                    <template v-slot:activator="{ props }">
                                      <v-icon text size="x-small" style="
                                            position: absolute;
                                            top: 0px;
                                            right: 0px;
                                          " v-bind="props">mdi-information-outline</v-icon>
                                    </template>
                                    <span>{{ $t("_InfoMinute") }}</span>
                                  </v-tooltip>
                                </template>
                              </v-text-field>
                            </v-col>
                          </v-row>
                        </div>
                      </v-col>
                      <v-col cols="4" style="height: 160px;display: flex;align-items: flex-start;">

                        <v-divider vertical class="memory-card__divider ml-3"></v-divider>

                        <div class="memory-card__long" style="margin-left: 20px;">
                          <div class="memory-section-header" style="display: flex;flex-direction: column;align-items: flex-start;">
                            <div class="d-flex align-center">
                              <div class="memory-icon">
                                <Icon icon="fluent:brain-sparkle-20-filled" style="font-size: 28px;color: #C32E0E" />
                              </div>
                              <div>
                                <h4 class="memory-title">Long-Term Memory</h4>
                              </div>
                            </div>
                            <div style="margin-top: 20px;padding-left: 10px;display: flex;justify-content: flex-start;flex-direction: column;">
                              <p class="memory-status mb-0">{{ longTermMemoryStatus }}</p>
                              <v-switch id="checkbox-longterm-memory-modelmanagement"
                              style="margin-left: -6px;"
                              :class="[
                                    'publication-toggle',
                                    LLmsModel.IsLongTerm_Memory
                                      ? 'publication-toggle--active'
                                      : 'publication-toggle--inactive'
                                  ]"inset hide-details
                                :aria-label="$t('_InfoLongtermMemory')"
                                :disabled="LLmsModel.provider == 'Google'" v-model="LLmsModel.IsLongTerm_Memory">
                                <template v-slot:label>
                                  <v-tooltip location="top" max-width="300">
                                    <template v-slot:activator="{ props }">
                                      <label class="sr-only" v-bind="props">Toggle Long-Term Memory</label>
                                    </template>
                                    <span>{{ $t("_InfoLongtermMemory") }}</span>
                                  </v-tooltip>
                                </template>
                              </v-switch>
                            </div>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </div>

                  <v-row class="multi-turn-section align-center" dense>
                    <v-col cols="8" class="d-flex align-center" style="gap: 26px;">
                      <div class="multi-turn-toggle">
                        <span style="font-weight: 500;">{{ $t('_InfoMultiTurnInput') }}</span>
                        <v-switch id="enablemulti-turninput-checkbox-modelmanagement" inset
                          :class="[
                            'publication-toggle',
                            LLmsModel.IsChainMassage
                              ? 'publication-toggle--active'
                              : 'publication-toggle--inactive'
                          ]"
                          hide-details v-model="LLmsModel.IsChainMassage">
                        </v-switch>
                      </div>
                      <div class="col-label-input" style="min-width: 300px;">
                        <span>Sequence</span>
                        <v-text-field id="sequence-field-modelmanagement" :placeholder="'Sequence'" density="comfortable"
                          :disabled="!LLmsModel.IsChainMassage" v-model="LLmsModel.LenChainMassage" clearable
                          variant="outlined" @keypress="isNumberpositive($event)" :rules="[checkValidate()]"
                          hide-details>
                          <template v-slot:append-outer>
                            <v-tooltip location="top">
                              <template v-slot:activator="{ props }">
                                <v-icon text size="x-small" style="
                                      position: absolute;
                                      top: 0px;
                                      right: -6px;
                                    " v-bind="props">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t("_InfoSequence") }}</span>
                            </v-tooltip>
                          </template>
                        </v-text-field>
                      </div>
                      <div class="col-label-input" style="min-width: 300px;">
                        <span>Duration (Seconds)</span>
                        <v-text-field id="duration-field-modelmanagement" :placeholder="'Duration (Seconds)'" density="comfortable"
                          :disabled="!LLmsModel.IsChainMassage" v-model="LLmsModel.TimeSecondChainMassage" clearable
                          variant="outlined" @keypress="isNumberpositive($event)" :rules="[checkValidate()]"
                          hide-details>
                          <template v-slot:append-outer>
                            <v-tooltip location="top">
                              <template v-slot:activator="{ props }">
                                <v-icon text size="x-small" style="
                                      position: absolute;
                                      top: 0px;
                                      right: -6px;
                                    " v-bind="props">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t("_InfoTimeSeconds") }}</span>
                            </v-tooltip>
                          </template>
                        </v-text-field>
                      </div>
                    </v-col>
                  </v-row>

                  <!-- Parameters -->
                  <v-row>
                    <v-col cols="12">
                      <span style="font-weight: 500;">Parameters</span>
                    </v-col>
                    <v-col cols="4" class="col-label-input">
                      <span>Temperature (0-1)</span>
                      <v-text-field id="temperature-field-modelmanagement" :placeholder="'Temperature'"
                        class="rounded-input padding-input2"
                        v-model="LLmsModel.temperature" density="compact" @keypress="isNumber($event)"
                        variant="outlined" :rules="[validateInput0_1(LLmsModel.temperature)]" required>
                        <template v-slot:append-outer>
                          <v-tooltip location="top" max-width="300">
                            <template v-slot:activator="{ props }">
                              <v-icon text size="x-small" style="
                                    position: absolute;
                                    top: 0px;
                                    right: -6px;
                                  " v-bind="props">mdi-information-outline</v-icon>
                            </template>
                            <span>{{ $t("_InfoTemperature") }}</span>
                          </v-tooltip>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="4" class="col-label-input">
                      <span>Top P (0-1)</span>
                      <v-text-field id="topP-field-modelmanagement" :placeholder="'Top P'"
                        class="rounded-input padding-input2"
                         v-model="LLmsModel.topP"
                        @keypress="isNumber($event)" variant="outlined" density="compact"
                        :disabled="LLmsModel.provider == 'Anthropic'" :rules="[validateInput0_1(LLmsModel.topP)]"
                        required>
                        <template v-slot:append-outer>
                          <v-tooltip location="top" max-width="300">
                            <template v-slot:activator="{ props }">
                              <v-icon text size="x-small" style="
                                    position: absolute;
                                    top: 0px;
                                    right: -6px;
                                  " v-bind="props">mdi-information-outline</v-icon>
                            </template>
                            <span>{{ $t("_InfoTopP") }}</span>
                          </v-tooltip>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="4" class="col-label-input">
                      <span>Frequency Penalty (0-2)</span>
                      <v-text-field id="frequency-penalty-modelmanagement" :placeholder="'Frequency Penalty'"
                        class="rounded-input padding-input2"
                        :disabled="LLmsModel.provider == 'Anthropic'" v-model="LLmsModel.frequencyPenalty"
                        @keypress="isNumber($event)" variant="outlined" density="compact" :rules="[
                          validateInput0_2(LLmsModel.frequencyPenalty),
                        ]">
                        <template v-slot:append-outer>
                          <v-tooltip location="top" max-width="300">
                            <template v-slot:activator="{ props }">
                              <v-icon text size="x-small" style="
                                    position: absolute;
                                    top: 0px;
                                    right: -6px;
                                  " v-bind="props">mdi-information-outline</v-icon>
                            </template>
                            <span>{{ $t("_InfoFrequencyPenalty") }}</span>
                          </v-tooltip>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="4" class="col-label-input">
                      <span>Presence Penalty (0-2)</span>
                      <v-text-field id="presence-penalty-modelmanagement" :placeholder="'Presence Penalty'"
                        class="rounded-input padding-input2"
                        :disabled="LLmsModel.provider == 'Anthropic'" v-model="LLmsModel.presencePenalty"
                        @keypress="isNumber($event)" variant="outlined" density="compact"
                        :rules="[validateInput0_2(LLmsModel.presencePenalty)]">
                        <template v-slot:append-outer>
                          <v-tooltip location="top" max-width="300">
                            <template v-slot:activator="{ props }">
                              <v-icon text size="x-small" style="
                                    position: absolute;
                                    top: 0px;
                                    right: -6px;
                                  " v-bind="props">mdi-information-outline</v-icon>
                            </template>
                            <span>{{ $t("_InfoPresencePenalty") }}</span>
                          </v-tooltip>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="4" class="col-label-input">
                      <span>Max Tokens Response</span>
                      <v-text-field id="max-tokens-response-modelmanagement" :placeholder="'Max Tokens Response'"
                        class="rounded-input padding-input2"
                         clearable
                        variant="outlined" density="compact" @keypress="isNumberpositive($event)"
                        v-model="LLmsModel.maxTokens" :error="error.maxTokens.error"
                        :error-messages="error.maxTokens.message">
                        <template v-slot:append-outer>
                          <v-tooltip location="top" max-width="300">
                            <template v-slot:activator="{ props }">
                              <v-icon text size="x-small" style="
                                    position: absolute;
                                    top: 0px;
                                    right: -6px;
                                  " v-bind="props">mdi-information-outline</v-icon>
                            </template>
                            <span>{{ $t("_InfoMaxToken") }}</span>
                          </v-tooltip>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="4" class="col-label-input">
                      <span>Stop Sequence</span>
                      <v-text-field id="stop-sequence-modelmanagement" :placeholder="'Stop Sequence'"
                        class="rounded-input padding-input2"
                         v-model="LLmsModel.stop"
                        variant="outlined" density="compact">
                        <template v-slot:append-outer>
                          <v-tooltip location="top" max-width="300">
                            <template v-slot:activator="{ props }">
                              <v-icon text size="x-small" style="
                                    position: absolute;
                                    top: 0px;
                                    right: -6px;
                                  " v-bind="props">mdi-information-outline</v-icon>
                            </template>
                            <span>
                              {{ $t("_InfoStop") }}
                            </span>
                          </v-tooltip>
                        </template>
                      </v-text-field>
                    </v-col>
                    
                    <v-col cols="4" class="col-label-input">
                      <span>Gender</span>
                      <v-select id="gender-autocomplete-modelmanagement" v-model="LLmsModel.gender" :items="DDGender"
                        class="rounded-input padding-input2"
                        item-title="name" item-value="id" placeholder="Gender" density="compact" variant="outlined"/>
                    </v-col>
                  </v-row>
                  
                </template>
              </v-expansion-panel>
            </v-expansion-panels>

            <v-expansion-panels class="modern-panels" :elevation="3">
              <v-expansion-panel>
                <template v-slot:title>
                  <div class="d-flex align-center panel-header py-2" style="padding-left: 22px;">
                    <Icon icon="fluent:settings-chat-16-filled" style="font-size: 22px;color: #C32E0E" />
                    <span class="header">Chat Setting</span>
                  </div>
                </template>
                <template v-slot:text>
                  <v-row style="margin: 5px 0px; border-top: 1px solid #e5e7eb;margin-top: -22px;padding-top: 0px;"></v-row>
                  <v-row>
                    <v-col cols="4">
                        <v-card class="option-card d-flex flex-column" :class="{ 'option-active': LLmsModel.isStream }"
                          :style=" LLmsModel.isStream ? 'background: #FFF2F2;' : '' "
                          flat height="100%" min-height="90px">
                          <div class="d-flex justify-space-between align-start">
                            <div class="option-header">
                              <div class="d-flex align-center">
                                <span style="font-weight: 600;">Stream Response</span>
                                <v-tooltip top max-width="300">
                                  <template v-slot:activator="{ props: attrs, on }">
                                    <v-icon small color="grey lighten-1" v-bind="attrs" v-on="on"
                                      class="ml-1">mdi-information-outline</v-icon>
                                  </template>
                                  <span>{{ $t('_InfoStream') }}</span>
                                </v-tooltip>
                              </div>
                              <div class="grey--text text-caption mt-1" v-if="LLmsModel.isStream">
                                Chat response appears gradually while loading
                              </div>
                              <div class="grey--text text-caption mt-1" v-else>
                                Full chat response displays after processing
                              </div>
                            </div>
                            <v-switch id="switch-stream-ModelManagement" v-model="LLmsModel.isStream" 
                            :class="[
                              'publication-toggle',
                              LLmsModel.isStream
                                ? 'publication-toggle--active'
                                : 'publication-toggle--inactive'
                            ]"
                              hide-details dense class="mt-0" inset></v-switch>
                          </div>
                        </v-card>
                    </v-col>
                    <v-col cols="4" class="col-label-input">
                      <div class="d-flex align-center">
                      <span :style="LLmsModel.isStream ? '' : 'color:rgba(55, 65, 81, 0.6);'">Typing Delay (ms)</span>
                      <v-tooltip location="top" max-width="300">
                        <template v-slot:activator="{ props }">
                          <v-icon small color="grey lighten-1" v-bind="props"
                            class="ml-1">mdi-information-outline</v-icon>
                        </template>
                        <span>Sets the delay between each character displayed 
                          during streaming. The value is in milliseconds (ms)</span>
                      </v-tooltip>
                      </div>
                      <v-text-field id="typingspeed-field-modelmanagement" v-model.number="LLmsModel.typingSpeed"
                        class="rounded-input padding-input2" :class="LLmsModel.isStream ? 'input--enabled' : 'input--disabled'"
                        :readonly="!LLmsModel.isStream"
                        placeholder="Typing Speed" type="number" min="0" density="compact" variant="outlined"
                        @keypress="isNumberpositive($event)"persistent-hint></v-text-field>
                    </v-col>
                    <v-col cols="4" class="col-label-input">
                      <span>Max Input Length</span>
                      <v-text-field id="maxinputlength-field-modelmanagement"
                        v-model.number="LLmsModel.maximumChatInput" placeholder="Max Input Length" type="number" min="0"
                        max="999999" density="compact" variant="outlined" class="rounded-input padding-input"
                        :rules="[rules.required]" @keypress="maxNumberpositive($event)"
                        persistent-hint></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <!-- Feedback Option -->
                    <v-col cols="4">
                      <v-card class="option-card d-flex flex-column"
                        :class="{ 'option-active': LLmsModel.isFeedback }"
                        :style=" LLmsModel.isFeedback ? 'background: #FFF2F2;' : '' "
                        flat height="100%" min-height="90px">
                        <div class="d-flex justify-space-between align-start">
                          <div class="option-header">
                            <div class="d-flex align-center">
                              <span style="font-weight: 600;">Collect Feedback</span>
                              <v-tooltip top max-width="300">
                                <template v-slot:activator="{ props: attrs, on }">
                                  <v-icon small color="grey lighten-1" v-bind="attrs" v-on="on"
                                    class="ml-1">mdi-information-outline</v-icon>
                                </template>
                                <span>{{ $t('_InfoFeedback') }}</span>
                              </v-tooltip>
                            </div>
                            <div class="grey--text text-caption mt-1">
                              Allow users to rate responses
                            </div>
                          </div>
                          <v-switch id="switch-feedback-ModelManagement" v-model="LLmsModel.isFeedback" 
                            :class="[
                              'publication-toggle',
                              LLmsModel.isFeedback
                                ? 'publication-toggle--active'
                                : 'publication-toggle--inactive'
                            ]"
                            color="primary" hide-details dense class="mt-0" inset></v-switch>
                        </div>
                      </v-card>
                    </v-col>

                    <!--  Image Upload Settings -->
                    <v-col cols="8">
                      <v-row :style=" LLmsModel.isAllowImage ? 'background: #FFF2F2; border-radius: 10px; max-height: 90px; margin-top:0px; margin-left:0px' : '' ">
                        <v-col cols="6" :style="LLmsModel.isAllowImage? 'padding-top: 0px; padding-left:0px;' : 'padding-top: 12px;'">
                          <v-hover>
                            <template v-slot:default="{ hover }">
                              <v-card
                                class="option-card d-flex flex-column"
                                :class="{
                                  'on-hover': hover,
                                  'option-active': LLmsModel.isAllowImage && showFileUpload
                                }"
                                flat
                                height="100%"
                                :style="LLmsModel.isAllowImage ? 'background: #FFF2F2;' : ''"
                                :min-height="LLmsModel.isAllowImage && showFileUpload ? '90px' : '90px'"
                              >
                                <div class="d-flex justify-space-between align-start flex-wrap">
                                  <!-- Left Side (Label + Info) -->
                                  <div class="option-header">
                                    <div class="d-flex align-center">
                                      <span style="font-weight: 600;">Image Upload</span>
                                      <v-tooltip location="top" max-width="300">
                                        <template v-slot:activator="{ props }">
                                          <v-icon
                                            small
                                            color="grey lighten-1"
                                            v-bind="props"
                                            class="ml-1"
                                          >
                                            mdi-information-outline
                                          </v-icon>
                                        </template>
                                        <span>{{ $t('_InfoImageUpload') }}</span>
                                      </v-tooltip>
                                    </div>
                                    <div class="grey--text text-caption mt-1">
                                      Allow users to upload images for analysis
                                    </div>
                                  </div>

                                  <!-- Switch -->
                                  <v-switch
                                    id="fileupload-checkbox-modelmanagement"
                                    v-model="LLmsModel.isAllowImage"
                                    :class="[
                                      'publication-toggle',
                                      LLmsModel.isAllowImage
                                        ? 'publication-toggle--active'
                                        : 'publication-toggle--inactive'
                                    ]"
                                    :disabled="!showFileUpload"
                                    color="primary"
                                    hide-details
                                    dense
                                    class="mt-0 ml-3"
                                    inset
                                  ></v-switch>
                                </div>
                              </v-card>
                            </template>
                          </v-hover>
                        </v-col>
                        <v-col cols="6" :style="LLmsModel.isAllowImage? 'padding-top: 0px;' : 'padding-top: 12px;'">
                          <v-card class="d-flex flex-column"
                            :class="{ 'option-active': LLmsModel.isAllowImage }"
                            :style=" LLmsModel.isAllowImage ? 'background: #FFF2F2;' : '' "
                            flat height="100%" min-height="90px">
                              <div v-if="LLmsModel.isAllowImage" style="margin-top: 10px;" class="additional-content">
                                  <v-text-field
                                    v-if="LLmsModel.isAllowImage && showFileUpload"
                                    id="fileuploadlimit-field-modelmanagement"
                                    placeholder="Maximum file size"
                                    @keypress="validateNumber($event)"
                                    @paste="validateNumber($event)"
                                    v-model.number="LLmsModel.fileUploadLimit"
                                    density="compact"
                                    variant="outlined"
                                    hide-details="auto"
                                    class="rounded-input padding-input input--enabled ml-4"
                                    style="max-width: 400px;"
                                    hint="Recommended: 1024KB for most cases"
                                    persistent-hint
                                    :rules="[rules.required]"
                                  >
                                    <template v-slot:append-inner>
                                      <v-chip
                                        size="small"
                                        color="blue-grey lighten-1"
                                        text-color="white"
                                        class="file-size-chip"
                                      >
                                        KB
                                      </v-chip>
                                    </template>

                                    <template v-slot:append>
                                      <v-tooltip location="top" max-width="300">
                                        <template v-slot:activator="{ props }">
                                          <v-icon
                                            small
                                            color="grey-darken-1"
                                            v-bind="props"
                                            class="info-icon-enhanced"
                                          >
                                            mdi-information-outline
                                          </v-icon>
                                        </template>
                                        <span>{{ $t('_InfoMaximumFileUpload') }}</span>
                                      </v-tooltip>
                                    </template>
                                  </v-text-field>
                              </div>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row>
                    <!-- LLM Changing -->
                    <v-col cols="4">
                      <v-card class="option-card d-flex flex-column"
                        :class="{ 'option-active': LLmsModel.isAllowLLMChange }"
                        :style=" LLmsModel.isAllowLLMChange ? 'background: #FFF2F2;' : '' "
                        flat height="100%" min-height="90px">
                        <div class="d-flex justify-space-between align-start">
                          <div class="option-header">
                            <div class="d-flex align-center">
                              <span style="font-weight: 600;">LLM Selection</span>
                              <v-tooltip top max-width="300">
                                <template v-slot:activator="{ props: attrs, on }">
                                  <v-icon small color="grey lighten-1" v-bind="attrs" v-on="on"
                                    class="ml-1">mdi-information-outline</v-icon>
                                </template>
                                <span>Allow users to change the LLM model during chat sessions</span>
                              </v-tooltip>
                            </div>
                            <div class="grey--text text-caption mt-1">
                              Allow model switching in chat
                            </div>
                          </div>
                          <v-switch id="llm-selection-switch-modelmanagement" v-model="LLmsModel.isAllowLLMChange"
                            :class="[
                              'publication-toggle',
                              LLmsModel.isAllowLLMChange
                                ? 'publication-toggle--active'
                                : 'publication-toggle--inactive'
                            ]"
                            color="primary" hide-details dense class="mt-0" inset></v-switch>
                        </div>
                      </v-card>
                    </v-col>
                    
                    <!-- Time Settings -->
                    <v-col cols="8">
                      <v-row :style=" LLmsModel.enableTime ? 'background: #FFF2F2; border-radius: 10px; max-height: 90px; margin-top:0px; margin-left:0px' : '' ">
                        <v-col cols="6" :style="LLmsModel.enableTime? 'padding-top: 0px; padding-left:0px;' : 'padding-top: 12px;'">
                          <v-hover>
                            <template v-slot:default="{ hover }">
                              <v-card class="option-card d-flex flex-column" :class="{
                                'on-hover': hover,
                                'option-active': LLmsModel.enableTime
                              }" 
                              :style=" LLmsModel.enableTime ? 'background: #FFF2F2;' : '' "
                              flat height="100%" min-height="90px">
                                <div class="d-flex justify-space-between align-start">
                                  <div class="option-header">
                                    <div class="d-flex align-center">
                                      <span style="font-weight: 600;">Time Context</span>
                                      <v-tooltip location="top" max-width="300">
                                        <template v-slot:activator="{ props }">
                                          <v-icon small color="grey lighten-1" v-bind="props"
                                            class="ml-1">mdi-information-outline</v-icon>
                                        </template>
                                        <span>{{ $t('_InfoEnableTime') }}</span>
                                      </v-tooltip>
                                    </div>
                                    <div class="grey--text text-caption mt-1">
                                      Enable time awareness in responses
                                    </div>
                                  </div>
                                  <v-switch id="Enabletime-modelmanagement" v-model="LLmsModel.enableTime"
                                    :class="[
                                      'publication-toggle',
                                      LLmsModel.enableTime
                                        ? 'publication-toggle--active'
                                        : 'publication-toggle--inactive'
                                    ]"
                                    hide-details dense class="mt-0" inset></v-switch>
                                </div>
                              </v-card>
                            </template>
                          </v-hover>
                        </v-col>
                        <v-col cols="6" :style="LLmsModel.enableTime? 'padding-top: 0px;' : 'padding-top: 12px;'">
                          <v-card class="d-flex flex-column"
                            :class="{ 'option-active': LLmsModel.enableTime }"
                            :style=" LLmsModel.enableTime ? 'background: #FFF2F2;' : '' "
                            flat height="100%" min-height="90px">
                              <div v-if="LLmsModel.enableTime" style="margin-top: 12px;" class="additional-content">
                                <v-select id="timezone-modelmanagement" v-model="LLmsModel.timeZone"
                                  :items="DDTimeZone" item-title="name" item-value="value" label="Time Zone"
                                  density="compact" variant="outlined" hide-details="auto" background-color="white"
                                  class="timezone-field rounded-input padding-input input--enabled" placeholder="Select your timezone">

                                  <template v-slot:selection="{ item }">
                                    <div style="padding: 7px;" class="timezone-selection d-flex align-center">
                                      <v-icon small color="primary" class="mr-2">mdi-map-marker</v-icon>
                                      <span class="font-weight-medium">{{ item.raw.name }}</span>
                                      <v-chip size="x-small" color="grey-darken-1" text-color="white"
                                        class="ml-2 timezone-code">
                                        {{ item.raw.value.split('/')[1].replace('_', ' ') }}
                                      </v-chip>
                                    </div>
                                  </template>

                                  <template v-slot:item="{ props, item, index }">
                                    <v-list-item v-bind="props" class="timezone-item"
                                      :id="'timezone-modelmanagement-option-' + index"
                                      :value="item.raw.name"
                                    >
                                      <template v-slot:title>
                                        <div class="timezone-item-content">
                                          <span class="timezone-country font-weight-medium"
                                            style="margin-left: 5px;">{{ item.raw.name }}</span>
                                          <div class="timezone-details d-flex align-center mt-1">
                                            <v-chip size="x-small" color="grey-darken-1" text-color="white"
                                              class="timezone-code">{{ item.raw.value.replace('_', ' ') }}
                                            </v-chip>
                                          </div>
                                        </div>
                                      </template>
                                    </v-list-item>
                                  </template>
                                </v-select>
                              </div>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row>
                    <!-- Reasoning Effort -->
                    <v-col cols="4">
                      <transition name="fade">
                        <v-card v-if="showReasoningEffort" class="option-card d-flex flex-column"
                        style="background-color: #FFF2F2;"
                          :class="{ 'option-active': LLmsModel.reasoningEffort }" flat height="100%"
                          min-height="90px">
                          <div class="d-flex justify-space-between align-start">
                            <div class="option-header mb-auto">
                              <div class="d-flex align-center">
                                <span style="font-weight: 600;">Reasoning Effort</span>
                                <v-tooltip top max-width="300">
                                  <template v-slot:activator="{ props }">
                                    <v-icon small color="grey lighten-1" v-bind="props"
                                      class="ml-1">mdi-information-outline</v-icon>
                                  </template>
                                  <span>Level of reasoning depth for responses</span>
                                </v-tooltip>
                              </div>
                            </div>
                          </div>

                          <v-select id="reasoning-ModelManagement" v-model="LLmsModel.reasoningEffort"
                            :items="reasonOptions" :class="LLmsModel.reasoningEffort ? 'input--enabled' : 'input--disabled'"
                            :rules="showReasoningEffort ? [rules.required] : [rules.notRequired]" item-title="text"
                            item-value="value" density="compact" variant="outlined" hide-details
                            placeholder="Select level"
                            class="mt-1 rounded-input padding-input">
                            <template v-slot:item="{ props, item, index }">
                              <v-list-item 
                                v-bind="props" 
                                :id="'reasoningeffort-gptmodeldetail-option-' + index" 
                                :value="item.raw.text"
                              >
                                <template v-slot:title>
                                  <span>{{ item.raw.text }}</span>
                                </template>
                              </v-list-item>
                            </template>
                            <template v-slot:selection="{ item }">
                              <div class="d-flex align-center">
                                <v-chip size="small" :color="getReasoningColor(item.raw.value)" text-color="white"
                                  class="px-3 reasoning-chip">
                                  {{ item.raw.text }}
                                </v-chip>
                              </div>
                            </template>
                          </v-select>
                        </v-card>
                      </transition>
                    </v-col>
                  </v-row>

                  <!-- Line Configuration -->
                  <v-row style="background-color: #FFF2F2;border-radius: 15px;padding: 10px;margin-top: 30px;">
                    <v-col cols="12">
                      <v-row>
                        <v-col cols="12">
                          <span style="display: flex;flex-direction: row; align-items: center;font-size: 16px;font-weight: 600;"> 
                            <v-img :src="images.line" alt="Line Icon" max-width="26" class="mr-2" />
                            Line Configuration
                          </span>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="3">
                          <v-switch id="loadingbar-enabled-switch-modelmanagement"
                            :class="[
                              'publication-toggle',
                              LLmsModel.loadingBarFlag
                                ? 'publication-toggle--active'
                                : 'publication-toggle--inactive'
                            ]"
                            style="
                                display: inline-block;
                                margin-top: 20px;
                              " v-model="LLmsModel.loadingBarFlag"
                            :label="`Loading bar (${LLmsModel.loadingBarFlag ? 'Enabled' : 'Disabled'})`" color="primary"
                            @click="disabledConfig()" inset></v-switch>
                        </v-col>
                        <v-col cols="4" class="col-label-input">
                          <span>Loading duration</span>
                          <v-autocomplete id="loadingduration-autocomplete-modelmanagement" :placeholder="'Loading duration'"
                            class="rounded-input padding-input"
                            :class="LLmsModel.loadingBarFlag ? 'input--enabled' : 'input--disabled'"
                            :items="listLoadingDuration" variant="outlined" density="compact" clearable
                            v-model="LLmsModel.loadingBarDuration"
                            :disabled="!LLmsModel.loadingBarFlag" persistent-hint>
                            <template v-slot:item="{ props, item, index }">
                              <v-list-item 
                                v-bind="props" 
                                :id="'loadingduration-gptmodeldetail-option-' + index" 
                                :value="item.raw"
                              >
                                <template v-slot:title>
                                  <span>{{ item.raw }}</span>
                                </template>
                              </v-list-item>
                            </template>
                          </v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <span style="font-size: 16px;font-weight: 500;">Monitor</span>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="4" class="col-label-input">
                          <span>Monitor Line UserID</span>
                          <v-text-field id="monitor-line-userid-modelmanagement" :placeholder="'Monitor Line UserID'"
                            class="input--enabled rounded-input padding-input2"
                            v-model="LLmsModel.monitorLineUserID" variant="outlined" density="compact">
                            <template v-slot:append-outer>
                              <v-tooltip location="top" max-width="300">
                                <template v-slot:activator="{ props }">
                                  <v-icon text size="x-small" style="
                                        position: absolute;
                                        top: 0px;
                                        right: -6px;
                                      " v-bind="props">mdi-information-outline</v-icon>
                                </template>
                                <span>{{ $t("_InfoMonitorLINEUserid") }}</span>
                              </v-tooltip>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="4" class="col-label-input">
                          <span>Monitor Line Name</span>
                          <v-autocomplete id="monitor-line-name-modelmanagement" :placeholder="'Monitor Line Name'"
                            class="rounded-input padding-input2"
                            :items="listMonitorLineName" density="compact" clearable variant="outlined" item-title="name"
                            :class="LLmsModel.monitorSocialID ? 'input--enabled' : 'input--disabled'"
                            item-value="id" v-model="LLmsModel.monitorSocialID">
                            <template v-slot:item="{ props, item, index }">
                              <v-list-item 
                                v-bind="props" 
                                :id="'monitor-line-name-gptmodeldetail-option-' + index" 
                                :value="item.raw.name"
                              >
                                <template v-slot:title>
                                  <span>{{ item.raw.name }}</span>
                                </template>
                              </v-list-item>
                            </template>
                            <template v-slot:activator="{ props }">
                              <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px"
                                v-bind="props">mdi-information-outline</v-icon>
                            </template>
                          </v-autocomplete>
                        </v-col>

                        <v-col cols="4">
                          <v-card class="option-card d-flex flex-column"
                            :class="{ 'option-active': LLmsModel.isShowNameUserMonitor }" flat height="100%"
                            :style=" LLmsModel.isShowNameUserMonitor ? 'background: #FFFFFF;' : 'background: #EDEDED;' "
                            min-height="90px">
                            <div class="d-flex justify-space-between align-start">
                              <div class="option-header">
                                <div class="d-flex align-center">
                                  <span class="font-weight-medium">Show Line Name</span>
                                  <v-tooltip location="top">
                                    <template v-slot:activator="{ props }">
                                      <v-icon small color="grey lighten-1" v-bind="props" class="ml-1">mdi-information-outline</v-icon>
                                    </template>
                                    <span>Display line name in the monitor view</span>
                                  </v-tooltip>
                                </div>
                                <div class="grey--text text-caption mt-1">
                                  Include line name in monitoring interface
                                </div>
                              </div>
                              <v-switch id="showname-usermonitor-switch" v-model="LLmsModel.isShowNameUserMonitor"
                                :class="[
                                  'publication-toggle',
                                  LLmsModel.isShowNameUserMonitor
                                    ? 'publication-toggle--active'
                                    : 'publication-toggle--inactive'
                                ]"
                                hide-details class="mt-0" inset @click="disabledConfig()"></v-switch>
                            </div>
                          </v-card>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-toolbar-title style="font-size: 16px">Forbidden word</v-toolbar-title>
                        </v-col>
                      </v-row>
                      <div class="forbidden-container">
                        <div v-if="!LLmsModel.forbiddenWord || LLmsModel.forbiddenWord.length === 0"
                          class="forbidden-empty">
                          <span>No forbidden words added yet.</span>
                        </div>
                        <transition-group name="forbidden-fade" tag="div" class="forbidden-list">
                          <div class="forbidden-item" v-for="(item, index) in LLmsModel.forbiddenWord" :key="`forbidden-${index}`">
                            <div class="forbidden-index">{{ index + 1 }}</div>
                            <v-text-field :id="`forbiddenword-textfield-${index}`"
                              v-model="LLmsModel.forbiddenWord[index]" variant="outlined" density="compact"
                              class="forbidden-input" placeholder="Enter forbidden word" hide-details
                              @keydown.enter.prevent>
                              <template v-slot:append-outer>
                                <v-tooltip location="top" :open-delay="500">
                                  <template v-slot:activator="{ props }">
                                    <v-icon size="16" color="#9CA3AF" style="cursor: help" v-bind="props">
                                      mdi-information-outline
                                    </v-icon>
                                  </template>
                                  <span>Words or phrases to block from responses</span>
                                </v-tooltip>
                              </template>
                            </v-text-field>
                            <v-btn icon="mdi-delete-outline" variant="text" color="grey-darken-1"
                              class="forbidden-delete" @click="removeForbiddenWord(index)">
                              <v-tooltip location="top" :open-delay="300">
                                <template v-slot:activator="{ props }">
                                  <v-icon size="18" color="#EF4444" v-bind="props">mdi-delete-forever</v-icon>
                                </template>
                                <span>Remove</span>
                              </v-tooltip>
                            </v-btn>
                          </div>
                        </transition-group>
                        <div class="forbidden-footer">
                          <v-btn id="button-add-forbiddenword-modelmanagement" class="forbidden-add-btn"
                            variant="text" prepend-icon="mdi-plus"
                            @click="addForbiddenWord">
                            Add Word
                          </v-btn>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                  
                </template>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="page.includes('Playground')" cols="12" justify="end" align="end">
            <v-btn class="dialog-close-btn" style="
                  margin-left: 1em;
                  border-radius: 25.342px;
                  background: #faa91b;
                  width: 89.863px;
                " @click="closePlayground">CLOSE</v-btn>
            <v-btn class="dialog-save-btn" style="
                  margin-left: 1em;
                  border-radius: 25.342px;
                  background: #9747ff;
                  width: 89.863px;
                " @click="savePlayground">SAVE</v-btn>
          </v-col>
          <v-col v-else-if="page == 'Model Creator'" cols="12" justify="end" align="end">
            <!-- <v-btn class="white--text mt-3"
                    style="margin-left: 1em; border-radius: 25.342px; background: #faa91b; width: 89.863px"
                    to="/GPTModelManagement">CLOSE</v-btn>
                  <v-btn class="white--text mt-3"
                    style="margin-left: 1em; border-radius: 25.342px; background: #9747ff; width: 89.863px"
                    @click="Save('s')">SAVE</v-btn>
                  <v-btn class="white--text mt-3"
                    style="margin-left: 1em; border-radius: 25.342px; background: #9747ff; width: 120px"
                    @click="Save('s&c')">SAVE & CLOSE</v-btn> -->
          </v-col>
          <v-col v-else cols="12" justify="end" align="end">
            <div v-if="page != 'view model'">
              <v-btn class="dialog-close-btn" style="
                    margin-left: 1em;
                    border-radius: 25.342px;
                    background: #faa91b;
                    width: 89.863px;
                  " to="/GPTModelManagement">
                  <Icon icon="line-md:close" style="font-size: 22px;color: #C32E0E; margin-right: 8px;" />
                  CLOSE
                  </v-btn>
              <v-btn id="button-saveandclose-modelmanagement" class="dialog-save-btn" style="
                    margin-left: 1em;
                    border-radius: 25.342px;
                    background: #9747ff;
                    width: 180px !important;
                  " :disabled="saveLoading" @click="Save('s&c')">
                  <Icon icon="fluent:save-arrow-right-24-filled" style="font-size: 22px;color: #FFFFFF;margin-right: 8px;" />
                  SAVE & CLOSE
                  </v-btn>
              <v-btn class="dialog-save-btn-green" style="
                    margin-left: 1em;
                    border-radius: 25.342px;
                    width: 89.863px;
                  " :disabled="saveLoading" @click="Save('s')">
                  <Icon icon="basil:save-solid" style="font-size: 22px;color: #FFFFFF;margin-right: 8px;" />
                  SAVE
                </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-form>
      <!--showdialog-->
      <v-dialog v-model="dialogShowAll" width="500">
        <v-card max-width="500">
          <v-list density="compact" rounded>
            <v-subheader class="headline" style="
                  color: #1d4f81;
                  font-size: 20px;
                  border-radius: 5px;
                  writing-mode: horizontal-tb;
                ">Prompt Template</v-subheader>
            <v-divider :thickness="1" class="border-opacity-100"></v-divider>
            <v-container style="max-height: 400px; overflow-y: auto; overflow-x: hidden">
              <v-list-item v-for="(item, i) in filteredPromptTemplates" :key="i" @click="SetSelectPromptTemplate(item)">
                <template v-slot:title>
                  <span id="list-nameprompttemplateall-modelmanagement">{{
                    item.name
                  }}</span>
                </template>
              </v-list-item>
            </v-container>
          </v-list>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn id="button-close-popupshowall-modelmanagement" color="blue darken-1" variant="text"
              @click="dialogShowAll = false">
              {{ $t("close") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>

    <v-dialog width="400" :model-value="saveLoading || dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular indeterminate size="64" color="primary" class="mb-4"></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- <v-overlay :value="dialog || saveLoading">
      <v-dialog v-model="dialog" persistent width="300">
        <v-card color="#1976D2" dark>
          <v-card-text class="text-white">
            Loading Please Wait...
            <v-progress-linear
              indeterminate
              color="#FAA91B"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay> -->
  </div>
</template>
<script>
import checkPermissionTwo from "@/api/function.js";
import LogTrace from "@/api/function.js";
import editImg from "@/assets/edit1.png";
import deleteImg from "@/assets/delete1.png";
import lineIcon from "@/assets/brand/line-icon.png";
export default {
  name: "ModelManagement",
  mixins: [checkPermissionTwo, LogTrace],
  props: {
    LLmsModel: {
      type: Object,
      default: () => {
        return {
          typeLLM: 0,
          modelId: null,
          modelName: null,
          provider: null,
          model: null,
          APIVersion: null,
          extension: null,
          description: null,
          promptTemplate: "",
          gender: null,
          vectordbName: [],
          groupReplaceID: null,
          productGroupID: [],
          topVDB: null,
          productTopVDB: null,
          productCosine: null,
          internet: null,
          feedback: null,
          historyCount: null,
          historyMinute: null,
          temperature: null,
          topP: null,
          frequencyPenalty: null,
          presencePenalty: null,
          stop: null,
          maxTokens: null,
          isStream: false,
          isBypass: false,
          isFeedback: false,
          isAllowImage: false,
          fileUploadLimit: null,
          versioning: null,
          isPublish: true,
          modelIDGroup: null,
          modelDisplay: null,
          Len_ShortMemory: null,
          IsLongTerm_Memory: false,
          IsChainMassage: false,
          LenChainMassage: null,
          TimeSecondChainMassage: null,
          Cosine: null,
          DataIntegrationID: null,
          SqlModelID: null,
          promptSqlNoData: null,
          guardRailModelID: null,
          IntentGroupID: null,
          maximumChatInput: 200000,
          loadingBarFlag: false,
          loadingBarDuration: 0,
          forbiddenWord: [""],
          monitorLineUserID: null,
          monitorSocialID: null,
          isShowNameUserMonitor: false,
          modelType: null,
          styleImage: null,
          resFormatImage: null,
          quality: null,
          resolution: null,
          enableTime: null,
          timeZone: null,
          jsonRequest: null,
          reasoningEffort: null,
          endPointURL: null,
          apI_Key: null,
          isAllowLLMChange: false,
          flowGroupID: null,
        };
      },
    },
    // DDVector:{
    //     type: Array,
    //     default: ()=>{
    //         return [];
    //     }
    // },
    // listDataIntegration:{
    //     type: Array,
    //     default: ()=>{
    //         return [];
    //     }
    // },
    // listSqlExtract:{
    //     type: Array,
    //     default: ()=>{
    //         return [];
    //     }
    // },
    // DDGroupReplace:{
    //     type: Array,
    //     default: ()=>{
    //         return [];
    //     }
    // },
    // DDPromptTemplate:{
    //     type: Array,
    //     default: ()=>{
    //         return [];
    //     }
    // },
    // listDDProvider:{
    //     type: Array,
    //     default: ()=>{
    //         return [];
    //     }
    // },
    // listDDModel:{
    //     type: Array,
    //     default: ()=>{
    //         return [];
    //     }
    // },
    // listDDIntentGroup:{
    //     type: Array,
    //     default: ()=>{
    //         return [];
    //     }
    // },
    GetDDModel: {
      type: String,
      default: null,
    },
    // editAction: {
    //   type: Boolean,
    //   default: false,
    // },
    modelID: {
      type: String,
      default: null,
    },
    page: {
      type: String,
      default: "-",
    },
  },
  data: () => ({
    id: null,
    activeTab: 0,
    valid: true,
    checkbox1: false,
    dialog: false,
    tempID: 0,
    MenuID1: null,
    MenuID2: null,
    MenuID3: null,
    menuID: null,
    subMenuID: null,
    today: null,
    maxLengthChar: null,
    loading: true,
    switch1: true,
    enableFlag: false,
    txtToImgChecker: false,
    imageStyleOptions: [
      { text: "Natural", value: "natural" },
      { text: "Vivid", value: "vivid" },
    ],
    imageFormatOptions: [
      { text: "URL", value: "url" },
      { text: "Base64 json", value: "b64_json" },
    ],
    reasonOptions: [
      { text: "Low", value: "low" },
      { text: "Medium", value: "medium" },
      { text: "High", value: "high" },
    ],
    rules: {
      notRequired: () => true,
      required: (value) => !!value || "Required.",
    },
    GPTModel_isPublish: false,
    DDVector: [],
    DDGroupReplace: [],
    DDProductGroup: [],
    DDProvider: ["Azure", "Google"],
    listDataIntegration: [],
    listSqlExtract: [],
    listGuardRailModel: [],
    DDMinute: [
      {
        name: "0",
        value: 0,
      },
      {
        name: "2",
        value: -2,
      },
      {
        name: "10",
        value: -10,
      },
      {
        name: "30",
        value: -30,
      },
      {
        name: "60",
        value: -60,
      },
      {
        name: "720",
        value: -720,
      },
      {
        name: "1440",
        value: -1440,
      },
    ],
    DDModel: [
      {
        provider: "Azure",
        model: "gpt-35-turbo-chat",
        maxPrompt: 4000,
      },
      {
        provider: "Azure",
        model: "gpt-35-turbo-16k",
        maxPrompt: 8000,
      },
      {
        provider: "Azure",
        model: "gpt-4",
        maxPrompt: 6000,
      },
      {
        provider: "Azure Postgresql",
        model: "gpt-35-postgresql",
        maxPrompt: 4000,
      },
      {
        provider: "Azure Postgresql",
        model: "gpt-35-16k-postgresql",
        maxPrompt: 8000,
      },
      {
        provider: "Azure Postgresql",
        model: "gpt-4-postgresql",
        maxPrompt: 6000,
      },
      {
        provider: "Azure Internet",
        model: "gpt-35-Internet",
        maxPrompt: 4000,
      },
      {
        provider: "Azure Internet",
        model: "gpt-35-16k-Internet",
        maxPrompt: 8000,
      },
      {
        provider: "Azure Internet",
        model: "gpt-4-Internet",
        maxPrompt: 6000,
      },
      {
        provider: "Azure News",
        model: "gpt-35-turbo-chat",
        maxPrompt: 4000,
      },
      {
        provider: "Azure News",
        model: "gpt-35-turbo-16k",
        maxPrompt: 8000,
      },
      {
        provider: "Azure News",
        model: "gpt-4",
        maxPrompt: 6000,
      },
    ],
    DDModelShow: [],
    DDGender: [
      {
        id: "m",
        name: "Male",
      },
      {
        id: "f",
        name: "Female",
      },
    ],
    DDTimeZone: [
      {
        value: "Asia/Bangkok",
        name: "Thailand",
      },
      {
        value: "Asia/Hong_Kong",
        name: "Hong Kong",
      },
      {
        value: "Asia/Tokyo",
        name: "Japan",
      },
      {
        value: "America/New_York",
        name: "USA",
      },
      {
        value: "Europe/London",
        name: "England",
      },
      {
        value: "Australia/Sydney",
        name: "Australia",
      },
    ],
    images: {
      edit: editImg,
      delete: deleteImg,
      line: lineIcon,
    },
    listDDModel: [],
    listDDIntentGroup: [],
    listDDProvider: [],
    showMenu: false,
    x: 0,
    y: 0,
    DDPromptTemplate: [],
    DDGroupPromptTemplate: [],
    flowDropdown: [],
    PositionPromptTemplate: 0,
    showPromptTem: false,
    dialogShowAll: false,
  promptSqlNoDataDialog: false,
  promptSqlNoDataDraft: "",
    groupPromptTemplate: null,
    localEditAction: null,
    listLoadingDuration: [10, 20, 30, 40, 50, 60],
    listMonitorLineName: [],
    showFileUpload: false,
    showReasoningEffort: false,
    saveLoading: false,
    totalTokens: null,
    intentAutocompleteDisabled: false,
    workflowPanelOpen: false,
    error: {
      maxTokens: {
        error: false,
        message: ""
      }
    }
  }),

  watch: {
    // editAction(newVal) {
    //   this.localEditAction = newVal;
    // },
    "$route.params.id": function (newParam) {
      // อัพเดตค่าพารามิเตอร์ด้วยตัวเอง
      this.id = newParam;
    },
    "LLmsModel.provider": function (val) {
      if (val == null) {
        this.LLmsModel.vectordbName = [];
        this.LLmsModel.topVDB = null;
        this.LLmsModel.productGroupID = [];
        this.LLmsModel.productTopVDB = null;
      }
    },
    "LLmsModel.flowGroupID": {
      handler(newVal) {
        if (newVal) {
          this.LLmsModel.IntentGroupID = null;
        }
        this.intentAutocompleteDisabled = Boolean(newVal);
      },
      immediate: true,
    },
    LLmsModel(val) {
      let self = this;
      self.changeProvider(val.provider);
      self.changeModel(val.model);
    },
  },
  computed: {
    filteredPromptTemplates() {
      if (this.groupPromptTemplate === null) {
        return [];
      }
      return this.DDPromptTemplate.filter(
        (item) => item.groupPromptTemplateID === this.groupPromptTemplate
      );
    },
    searchedTemplates() {
      if (!this.templateSearchQuery) return this.filteredPromptTemplates;
      const query = this.templateSearchQuery.toLowerCase();
      return this.filteredPromptTemplates.filter(item =>
        item.name.toLowerCase().includes(query)
      );
    },
    intentHelperText() {
      return this.intentAutocompleteDisabled
        ? "*You cannot select an Intent while a Flow is active."
        : "";
    },
    promptSqlNoDataButtonIcon() {
      const value = this.LLmsModel?.promptSqlNoData;
      if (!value || value.trim() === "") {
        return "mdi-plus";
      }
      return "mdi-check";
    },
    promptSqlNoDataButtonText() {
      const value = this.LLmsModel?.promptSqlNoData;
      if (!value || value.trim() === "") {
        return "Customize No Data Message";
      }
      return "Using Custom Message";
    },
    longTermMemoryStatus() {
      const isEnabled = Boolean(this.LLmsModel?.IsLongTerm_Memory);
      return isEnabled ? "Long-Term Memory Enabled" : "Long-Term Memory Disabled";
    }
  },
  methods: {
    openPromptSqlNoDataDialog() {
      this.promptSqlNoDataDraft = this.LLmsModel?.promptSqlNoData ?? "";
      this.promptSqlNoDataDialog = true;
    },
    cancelPromptSqlNoDataDialog() {
      this.promptSqlNoDataDialog = false;
      this.promptSqlNoDataDraft = this.LLmsModel?.promptSqlNoData ?? "";
    },
    savePromptSqlNoData() {
      const value = this.promptSqlNoDataDraft?.trim();
      this.LLmsModel.promptSqlNoData = value && value !== "" ? value : null;
      this.promptSqlNoDataDialog = false;
    },
    getReasoningColor(level) {
      switch (level) {
        case 'low': return 'blue-grey';
        case 'medium': return 'blue darken-1';
        case 'high': return 'indigo darken-2';
        default: return 'grey';
      }
    },
    truncatePrompt(text) {
      if (!text) return '';
      return text.length > 60 ? text.substring(0, 60) + '...' : text;
    },
    addForbiddenWord() {
      if (!Array.isArray(this.LLmsModel.forbiddenWord)) {
        this.LLmsModel.forbiddenWord = [""];
      } else {
        this.LLmsModel.forbiddenWord.push("");
      }

      const newIndex = this.LLmsModel.forbiddenWord.length - 1;
      this.$nextTick(() => {
        const input = this.$el?.querySelector(`#forbiddenword-textfield-${newIndex} input`);
        if (input) {
          input.focus();
        }
      });
    },
    removeForbiddenWord(index) {
      if (!Array.isArray(this.LLmsModel.forbiddenWord) || this.LLmsModel.forbiddenWord.length === 0) {
        return;
      }

      if (this.LLmsModel.forbiddenWord.length <= 1) {
        this.LLmsModel.forbiddenWord.splice(0, 1, "");
      } else {
        this.LLmsModel.forbiddenWord.splice(index, 1);
      }
    },
    disabledConfig() {
      return (this.enableFlag = !this.LLmsModel.loadingBarFlag);
    },
    ShowPromptTemplate(e) {
      e.preventDefault();
      this.showMenu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },
    async SetSelectPromptTemplate(val) {
      let self = this;
      var strArray = self.LLmsModel.promptTemplate.split("");
      strArray.splice(self.PositionPromptTemplate, 0, val.prompt);
      self.LLmsModel.promptTemplate = strArray.join("");
    },
    validate() {
      this.$refs.form.validate();
    },
    async Get(id) {
      let self = this;
      self.dialog = true;
      self.loading = true;
      await self.$call.GetGPTModelById(
        id,
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            await self.Edit(dataResponse.data);
            await self.changeProvider(self.LLmsModel.provider);
            await self.changeModel(self.LLmsModel.model);
            self.disabledConfig();
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    async GetAllDDModelManagement() {
      const id = this.$route.query.id ?? this.LLmsModel.modelId;
      let self = this;
      self.dialog = true;
      await self.$call.GetAllDDModelManagement(
        id,
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDVector = dataResponse.data.vectorDBName;
            self.listDataIntegration = dataResponse.data.dataIntegration;
            self.DDGroupReplace = dataResponse.data.groupReplace;
            self.DDProductGroup = dataResponse.data.productGroup;
            self.DDProductGroup = dataResponse.data.productGroup;
            self.DDPromptTemplate = dataResponse.data.promptTemplate.listData;
            self.listDDProvider = dataResponse.data.provider;
            // self.listDDProvider.push({ providerName: "Other", id: 0 });
            self.listDDModel = dataResponse.data.modelData;
            self.listDDIntentGroup = dataResponse.data.intentGroup;
            self.DDGroupPromptTemplate = dataResponse.data.groupPromptTemplate;
            self.listMonitorLineName = dataResponse.data.monitorSocialLine;
            self.flowDropdown = dataResponse.data.flowDropdown;
            if (self.modelID) {
              // self.modelID = self.$route.query.id;
              self.listSqlExtract = dataResponse.data.modelPublih.filter((e) => e.idEncrypt != self.modelID && e.typeName == 'Bot');
            } else {
              self.listSqlExtract = dataResponse.data.modelPublih.filter((e) => e.typeName == 'Bot');
            }
            self.listGuardRailModel = dataResponse.data.modelPublih.filter(
              (e) => e.typeName == "GuardRail"
            );
          } else {
            self.DDVector = [];
            self.listDataIntegration = [];
            self.listSqlExtract = [];
            self.listGuardRailModel = [];
            self.DDGroupReplace = [];
            self.DDProductGroup = [];
            self.DDPromptTemplate = [];
            self.listDDProvider = [];
            self.listDDModel = [];
          }
          self.dialog = false;
          if (self.modelID != null) {
            await self.Get(self.modelID);

          }

          if (self.page.includes("Playground")) {
            this.localEditAction = self.page.includes("Edit");
            await self.changeProvider(self.LLmsModel.provider);
            await self.changeModel(self.LLmsModel.model);
          } else if (self.page == "view model") {
            this.localEditAction = false;
          } else {
            this.localEditAction = false;
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    Save(actions) {
      let self = this;
      if (self.validateMaxToken()) {
        return;
      }
      if (self.txtToImgChecker && self.LLmsModel.styleImage == null) {
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warning"),
          text: "Please select style image and response format image",
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
      if (
        self.LLmsModel.enableTime == true &&
        (self.LLmsModel.timeZone == null || self.LLmsModel.timeZone == "")
      ) {
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warning"),
          text: self.$t("warningEnableTime"),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
      if (self.LLmsModel.typeLLM == undefined) {
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warning"),
          text: self.$t("warningTypeLLM"),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
      if (
        self.showReasoningEffort &&
        (self.LLmsModel.reasoningEffort == null ||
          self.LLmsModel.reasoningEffort == "" ||
          self.LLmsModel.reasoningEffort == undefined)
      ) {
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warning"),
          text: self.$t("warningReasoningEffort"),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
      setTimeout(() => {
        self.validate();
      }, 100);
      let modelData = {
        modelId: self.LLmsModel.modelId,
        modelName: self.LLmsModel.modelName,
        provider: self.LLmsModel.provider,
        model: self.LLmsModel.model,
        APIVersion: self.LLmsModel.APIVersion,
        extension: self.LLmsModel.extension,
        description: self.LLmsModel.description,
        promptTemplate: self.LLmsModel.promptTemplate,
        gender: self.LLmsModel.gender,
        vectordbName:
          self.LLmsModel.vectordbName == null
            ? []
            : self.LLmsModel.vectordbName,
        groupReplaceID:
          self.LLmsModel.groupReplaceID == null
            ? []
            : self.LLmsModel.groupReplaceID,
        productGroupID:
          self.LLmsModel.productGroupID == null
            ? []
            : self.LLmsModel.productGroupID,
        topVDB: self.LLmsModel.topVDB !== "" ? self.LLmsModel.topVDB : null,
        productTopVDB: self.LLmsModel.productTopVDB !== "" ? self.LLmsModel.productTopVDB : null,
        productCosine: self.LLmsModel.productCosine !== "" ? self.LLmsModel.productTopVDB : null,
        internet: self.LLmsModel.internet,
        feedback: self.LLmsModel.feedback,
        historyCount: self.LLmsModel.historyCount,
        historyMinute:
          self.LLmsModel.historyMinute > 0
            ? -self.LLmsModel.historyMinute
            : self.LLmsModel.historyMinute,
        temperature: self.LLmsModel.temperature !== "" ? self.LLmsModel.temperature : null,
        topP: self.LLmsModel.topP !== "" ? self.LLmsModel.topP : null,
        frequencyPenalty: self.LLmsModel.frequencyPenalty !== "" ? self.LLmsModel.frequencyPenalty : null,
        presencePenalty: self.LLmsModel.presencePenalty !== "" ? self.LLmsModel.presencePenalty : null,
        stop: self.LLmsModel.stop !== "" ? self.LLmsModel.stop : null,
        maxTokens: self.LLmsModel.maxTokens == null || self.LLmsModel.maxTokens == '' ? self.totalTokens : self.LLmsModel.maxTokens,
        isStream: self.LLmsModel.isStream,
        // isBypass : self.LLmsModel.IsBypass,
        isFeedback: self.LLmsModel.isFeedback,
        isAllowImage: self.LLmsModel.isAllowImage,
        fileUploadLimit:
          self.LLmsModel.fileUploadLimit == null
            ? self.LLmsModel.fileUploadLimit
            : parseInt(self.LLmsModel.fileUploadLimit),
        versioning: self.LLmsModel.versioning,
        isPublish: self.LLmsModel.isPublish,
        modelIDGroup: self.LLmsModel.modelIDGroup,
        modelDisplay: self.LLmsModel.modelDisplay,
        Len_ShortMemory: self.LLmsModel.Len_ShortMemory ?? 200,
        IsLongTerm_Memory:
          self.LLmsModel.provider == "Google"
            ? false
            : self.LLmsModel.IsLongTerm_Memory ?? false,
        IsChainMassage: self.LLmsModel.IsChainMassage ?? false,
        LenChainMassage: self.LLmsModel.LenChainMassage,
        TimeSecondChainMassage: self.LLmsModel.TimeSecondChainMassage,
        Cosine: self.LLmsModel.Cosine,
        DataIntegrationID: self.LLmsModel.DataIntegrationID,
        SqlModelID: self.LLmsModel.SqlModelID,
        promptSqlNoData: self.LLmsModel.promptSqlNoData,
        IntentGroupID: self.LLmsModel.IntentGroupID,
        typingSpeed: parseInt(self.LLmsModel.typingSpeed),
        maximumChatInput:
          self.LLmsModel.maximumChatInput == null
            ? 200000
            : parseInt(self.LLmsModel.maximumChatInput),
        loadingBarFlag: self.LLmsModel.loadingBarFlag,
        loadingBarDuration: self.LLmsModel.loadingBarDuration,
        forbiddenWord: self.forbiddenWordSaveHandle(
          self.LLmsModel.forbiddenWord
        ),
        monitorLineUserID: self.LLmsModel.monitorLineUserID,
        isShowNameUserMonitor: self.LLmsModel.isShowNameUserMonitor,
        monitorSocialID: self.LLmsModel.monitorSocialID,
        styleImage: self.txtToImgChecker ? self.LLmsModel.styleImage : null,
        resFormatImage: self.txtToImgChecker ? "url" : null,
        modelType: self.LLmsModel.modelType,
        quality: self.txtToImgChecker ? self.LLmsModel.quality : null,
        resolution: self.txtToImgChecker ? self.LLmsModel.resolution : null,
        JsonRequest: self.LLmsModel.jsonRequest,
        typeLLM: self.LLmsModel.typeLLM == 1 ? "GuardRail" : "Bot",
        guardRailModelID:
          self.LLmsModel.typeLLM == 0 ? self.LLmsModel.guardRailModelID : null,
        timeZone: self.LLmsModel.enableTime ? self.LLmsModel.timeZone : null,
        reasoningEffort: self.showReasoningEffort
          ? self.LLmsModel.reasoningEffort
          : null,
        endPointURL:
          self.LLmsModel.endPointURL != "" && self.LLmsModel.endPointURL != null
            ? self.LLmsModel.endPointURL
            : null,
        apI_Key:
          self.LLmsModel.apI_Key != "" && self.LLmsModel.apI_Key != null
            ? self.LLmsModel.apI_Key
            : null,
        isAllowLLMChange: self.LLmsModel.isAllowLLMChange,
        flowGroupID: self.LLmsModel.flowGroupID,
      };

      if (self.LLmsModel.modelName == null || self.LLmsModel.modelName == "") {
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warning"),
          text: self.$t("warningModelName"),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      } else if (!self.LLmsModel.provider) {
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warning"),
          text: self.$t("warningProvider"),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      } else if (!self.LLmsModel.model) {
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warning"),
          text: self.$t("warningModel"),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      } else if (self.LLmsModel.isPublish == null) {
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warning"),
          text: self.$t("warningPublish"),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
      if (this.LLmsModel.IsChainMassage == true) {
        if (
          this.LLmsModel.LenChainMassage == null ||
          this.LLmsModel.LenChainMassage == "" ||
          this.LLmsModel.TimeSecondChainMassage == null ||
          this.LLmsModel.TimeSecondChainMassage == ""
        ) {
          self.$swal.fire({
            icon: "warning",
            title: self.$t("warning"),
            text: self.$t("warningChainMassage"),
            showConfirmButton: false,
            timer: 3000,
          });
          return;
        }
      } else if (
        self.LLmsModel.temperature == null ||
        self.LLmsModel.temperature < 0 ||
        self.LLmsModel.temperature > 1 ||
        self.LLmsModel.temperature === ""
      ) {
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warning"),
          text: self.$t("warningTemperature"),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      } else if (
        self.LLmsModel.topP == null ||
        self.LLmsModel.topP < 0 ||
        self.LLmsModel.topP > 1 ||
        self.LLmsModel.topP === ""
      ) {
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warning"),
          text: self.$t("warningTopP"),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      } else if (
        self.LLmsModel.maximumChatInput == null ||
        self.LLmsModel.maximumChatInput < 0 ||
        self.LLmsModel.maximumChatInput === ""
      ) {
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warning"),
          text: self.$t("warningmaximumChatInput"),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      } else if (
        self.LLmsModel.topVDB == null &&
        self.LLmsModel.vectordbName.length > 0
      ) {
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warning"),
          text: self.$t("warningTopVDB"),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      } else if (
        self.LLmsModel.productTopVDB == null &&
        self.LLmsModel.productGroupID.length > 0
      ) {
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warning"),
          text: self.$t("warningTopVDB"),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      } else if (
        (self.LLmsModel.APIVersion == "" ||
          self.LLmsModel.APIVersion == null) &&
        self.LLmsModel.provider != "Google" &&
        self.LLmsModel.provider != "Other"
      ) {
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warning"),
          text: self.$t("warningAPIVersion"),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
      if (
        typeof self.validatePrompt(self.LLmsModel.promptTemplate) == "string"
      ) {
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warning"),
          text: "Please Enter Correct Format!",
          showConfirmButton: false,
          timer: 1800,
        });
        return;
      }
      self.dialog = true;
      try {
        self.saveLoading = true;
        // console.log("Save actions:", self.saveLoading);
        self.LLmsModel.frequencyPenalty =
          self.LLmsModel.frequencyPenalty != ""
            ? self.LLmsModel.frequencyPenalty
            : null;
        self.LLmsModel.presencePenalty =
          self.LLmsModel.presencePenalty != ""
            ? self.LLmsModel.presencePenalty
            : null;
        self.LLmsModel.topVDB =
          self.LLmsModel.topVDB != "" ? self.LLmsModel.topVDB : null;
        self.LLmsModel.productTopVDB =
          self.LLmsModel.productTopVDB != ""
            ? self.LLmsModel.productTopVDB
            : null;
        self.LLmsModel.IsLongTerm_Memory =
          self.LLmsModel.provider == "Google"
            ? false
            : self.LLmsModel.IsLongTerm_Memory ?? false;
        self.LLmsModel.typingSpeed = parseInt(self.LLmsModel.typingSpeed);
        self.LLmsModel.maximumChatInput = parseInt(
          self.LLmsModel.maximumChatInput
        );
        // let cloneLLmsModel = Object.assign({}, self.LLmsModel);
        // cloneLLmsModel.forbiddenWord = self.forbiddenWordSaveHandle(self.LLmsModel.forbiddenWord)
        self.$call.AddGPTModel(
          modelData,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              let msgSuccess =
                self.page == "Edit Model" || self.localEditAction
                  ? "✔ Successfully Updated !"
                  : "✔ Successfully Created !";
              self.$swal.fire({
                title: msgSuccess,
                showConfirmButton: false,
                timer: 1500,
                position: 'top',
                background: 'transparent',
                customClass: {
                  popup: 'success-banner',
                  title: 'success-banner-title'
                },
                backdrop: false // **สำคัญ ถ้าไม่ต้องการบัง UI**
              });

              if (actions == "s&c") self.$router.push("/GPTModelManagement");
              else {
                self.$router
                  .push({
                    name: "GPTModelDetail",
                    query: {
                      id: dataResponse.data,
                    },
                  })
                  .then(() => {
                    self.Get(dataResponse.data);
                  });
              }
            }
            if (dataResponse.status == 1 && dataResponse.data.is_exist) {
              self.$swal.fire({
                icon: "error",
                title: "Model ID is exist",
                showConfirmButton: false,
                timer: 1800,
              });
            }
            self.saveLoading = false;
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            self.Adddialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    async Edit(item) {
      let self = this;
      if (self.page !== "Model Creator") {
        self.localEditAction = true;
      } else {
        self.localEditAction = null;
      }
      self.GPTModel_isPublish = item.isPublish;
      self.LLmsModel.modelId = item.modelID;
      self.LLmsModel.modelName = item.modelName;
      self.LLmsModel.provider = item.provider;
      self.LLmsModel.model = item.model;
      self.LLmsModel.APIVersion = item.apiVersion;
      self.LLmsModel.extension = item.extension;
      self.LLmsModel.description = item.description;
      self.LLmsModel.promptTemplate = item.promptTemplate;
      self.LLmsModel.gender = item.gender;
      self.LLmsModel.vectordbName = item.vectordbName;
      self.LLmsModel.groupReplaceID = item.groupReplaceID;
      self.LLmsModel.productGroupID = item.productGroupID ?? [];
      self.LLmsModel.topVDB = item.topVDB;
      self.LLmsModel.productTopVDB = item.productTopVDB;
      self.LLmsModel.productCosine = item.productCosine;
      self.LLmsModel.internet = item.internet;
      self.LLmsModel.feedback = item.feedback;
      self.LLmsModel.historyCount = item.historyCount;
      self.LLmsModel.historyMinute =
        item.historyMinute < 0
          ? Math.abs(item.historyMinute)
          : item.historyMinute;
      self.LLmsModel.temperature = item.temperature;
      self.LLmsModel.topP = item.top_p;
      self.LLmsModel.frequencyPenalty = item.frequency_penalty;
      self.LLmsModel.presencePenalty = item.presence_penalty;
      self.LLmsModel.stop = item.stop;
      self.LLmsModel.maxTokens = item.max_tokens;
      self.LLmsModel.isStream = item.isStream;
      self.LLmsModel.isBypass = item.isBypass;
      self.LLmsModel.isFeedback = item.isFeedback;
      self.LLmsModel.isAllowImage = item.isAllowImage;
      self.LLmsModel.fileUploadLimit =
        item.fileUploadLimit == null
          ? item.fileUploadLimit
          : parseInt(item.fileUploadLimit);
      self.LLmsModel.versioning = item.versioning;
      self.LLmsModel.isPublish =
        self.page == "view model"
          ? item.isPublish == null
            ? false
            : item.isPublish
          : item.isPublish;
      self.LLmsModel.modelIDGroup = item.modelIDGroup;
      self.LLmsModel.modelDisplay = item.modelDisplay;
      self.LLmsModel.Len_ShortMemory = item.len_ShortMemory ?? 200;
      self.LLmsModel.IsLongTerm_Memory =
        self.LLmsModel.provider == "Google"
          ? false
          : item.isLongTerm_Memory ?? false;
      self.LLmsModel.IsChainMassage = item.isChainMassage ?? false;
      self.LLmsModel.LenChainMassage = item.lenChainMassage;
      self.LLmsModel.TimeSecondChainMassage = item.timeSecondChainMassage;
      self.LLmsModel.Cosine = item.cosine;
      self.LLmsModel.DataIntegrationID = item.dataIntegrationID;
      self.LLmsModel.SqlModelID = item.sqlModelID;
      self.LLmsModel.promptSqlNoData = item.promptSqlNoData;
      self.LLmsModel.IntentGroupID = item.intentGroupID;
      self.LLmsModel.typingSpeed = parseInt(item.typingSpeed);
      self.LLmsModel.maximumChatInput =
        item.maximumChatInput == null
          ? 200000
          : parseInt(item.maximumChatInput);
      self.LLmsModel.loadingBarFlag = item.loadingBarFlag;
      self.LLmsModel.loadingBarDuration = item.loadingBarDuration;
      self.LLmsModel.forbiddenWord = self.forbiddenWordHandle(
        item.forbiddenWord
      ) ?? [""];
      self.LLmsModel.monitorLineUserID = item.monitorLineUserID;
      self.LLmsModel.isShowNameUserMonitor = item.isShowNameUserMonitor;
      self.LLmsModel.monitorSocialID = item.monitorSocialID;
      self.LLmsModel.typeLLM = item.typeLLM == "GuardRail" ? 1 : 0;
      self.LLmsModel.guardRailModelID = item.guardRailModelID;
      self.LLmsModel.modelType = item.modelType;
      self.LLmsModel.styleImage = item.styleImage;
      self.LLmsModel.resFormatImage = "url";
      self.LLmsModel.quality = item.quality;
      self.LLmsModel.resolution = item.resolution;
      self.LLmsModel.jsonRequest = item.jsonRequest;
      self.LLmsModel.enableTime = item.timeZone ? true : false;
      self.LLmsModel.timeZone = item.timeZone;
      self.LLmsModel.reasoningEffort = item.reasoningEffort;
      self.LLmsModel.endPointURL = item.endPointURL;
      self.LLmsModel.apI_Key = item.apI_Key;
      self.EditdialogUser = true;
      self.LLmsModel.isAllowLLMChange = item.isAllowLLMChange;
      self.LLmsModel.flowGroupID = item.flowGroupID;
      // let templistDDVector = self.DDVector.map((item) => item.name);
      // self.LLmsModel.vectordbName = self.LLmsModel.vectordbName.filter((item) =>
      //   templistDDVector.includes(item)
      // );
    },
    savePlayground() {
      let self = this;
      self.$emit("is-event", "SaveEdit");
    },
    closePlayground() {
      let self = this;
      self.$emit("is-event", "Close");
    },
    checkValidate() {
      if (
        this.LLmsModel.vectordbName != null &&
        this.LLmsModel.vectordbName != ""
      ) {
        if (this.LLmsModel.topVDB == "" || this.LLmsModel.topVDB == null) {
          return "Required.";
        } else if (parseInt(this.LLmsModel.topVDB) == 0) {
          return "Required.";
        }
      }
      if (this.LLmsModel.IsChainMassage == true) {
        if (
          this.LLmsModel.LenChainMassage == null ||
          this.LLmsModel.LenChainMassage == "" ||
          this.LLmsModel.TimeSecondChainMassage == null ||
          this.LLmsModel.TimeSecondChainMassage == ""
        ) {
          return "Required.";
        }
      }
      return true;
    },
    checkProductValidate() {
      if (
        this.LLmsModel.productGroupID != null &&
        this.LLmsModel.productGroupID != ""
      ) {
        if (
          this.LLmsModel.productTopVDB == "" ||
          this.LLmsModel.productTopVDB == null
        ) {
          return "Required.";
        } else if (parseInt(this.LLmsModel.productTopVDB) == 0) {
          return "Required.";
        }
      }
      return true;
    },
    isNumber: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46 &&
        charCode !== 45
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isNumberpositive: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    maxNumberpositive: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;

      let inputValue = evt.target.value.toString();
      let selectionStart = evt.target.selectionStart;
      let selectionEnd = evt.target.selectionEnd;
      let newValue;

      if (selectionStart !== selectionEnd) {
        // If there is a text selection, we need to replace the selected text
        newValue =
          inputValue.substring(0, selectionStart) +
          evt.key +
          inputValue.substring(selectionEnd);
      } else {
        // Otherwise, we are inserting the new character at the cursor position
        newValue =
          inputValue.substring(0, selectionStart) +
          evt.key +
          inputValue.substring(selectionStart);
      }

      if (
        charCode < 48 ||
        charCode > 57 || // Check if the key is not a number
        newValue.length > 6 || // Check if the length exceeds 6 characters
        parseInt(newValue) > 200000
      ) {
        // Check if the number exceeds 200000
        evt.preventDefault();
      } else {
        return true;
      }
    },
    validateNumber: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;

      let inputValue = evt.target.value.toString();
      let selectionStart = evt.target.selectionStart;
      let selectionEnd = evt.target.selectionEnd;
      let newValue;
      if (selectionStart !== selectionEnd) {
        // If there is a text selection, we need to replace the selected text
        newValue =
          inputValue.substring(0, selectionStart) +
          evt.key +
          inputValue.substring(selectionEnd);
      } else {
        // Otherwise, we are inserting the new character at the cursor position
        newValue =
          inputValue.substring(0, selectionStart) +
          evt.key +
          inputValue.substring(selectionStart);
      }

      if (
        charCode < 48 ||
        charCode > 57 || // Check if the key is not a number
        newValue.length > 5 || // Check if the length exceeds 4 characters
        parseInt(newValue) > 20000 // Check if the number exceeds 2048
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    validatePrompt(inputValue) {
      if (!inputValue) {
        return true;
      }
      if (this.maxLengthChar == null) {
        return true;
      } else {
        return (
          inputValue.length <= this.maxLengthChar ||
          "กรุณากรอกข้อมูลตัวอักษรไม่เกิน " +
          this.convertNumberToStringFormat(this.maxLengthChar)
        );
      }
    },
    validateInput0_1(inputValue) {
      // ตรวจสอบว่าข้อมูลที่ป้อนเข้ามาเป็นตัวเลขที่อยู่ระหว่าง 0 ถึง 1 ที่มีทศนิยม 2 ตำแหน่ง
      const value = parseFloat(inputValue);
      if (isNaN(value)) return "Required.";
      return (
        (value >= 0 && value <= 1 && this.isTwoDecimalPlaces(value)) ||
        "กรุณาป้อนตัวเลขระหว่าง 0 ถึง 1 ที่มีทศนิยม 2 ตำแหน่ง"
      );
    },
    validateInput0_2(inputValue) {
      // ตรวจสอบว่าข้อมูลที่ป้อนเข้ามาเป็นตัวเลขที่อยู่ระหว่าง 0 ถึง 2 ที่มีทศนิยม 2 ตำ๝หน่ง
      const value = parseFloat(inputValue);
      if (isNaN(value)) return true;
      return (
        (value >= 0 && value <= 2 && this.isTwoDecimalPlaces(value)) ||
        "กรุณาป้อนตัวเลขระหว่าง 0 ถึง 2 ที่มีทศนิยม 2 ตำแหน่ง"
      );
    },
    validateMaxToken() {
      this.error.maxTokens.error = false;
      this.error.maxTokens.message = "";
      if (this.LLmsModel.maxTokens > this.totalTokens && this.totalTokens != null) {
        this.error.maxTokens.error = true;
        this.error.maxTokens.message = "Max tokens cannot exceed the total tokens limit " + this.totalTokens;
        this.$swal.fire({
          icon: "warning",
          title: this.$t("warning"),
          text: this.error.maxTokens.message,
          showConfirmButton: false,
          timer: 3000,
          backdrop: false,
        });
        return true;
      }
      return false;
    },
    isTwoDecimalPlaces(number) {
      const regex = /^\d+(\.\d{1,2})?$/;
      return regex.test(number.toString());
    },
    convertNumberToStringFormat(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    customFilter(fn, listData) {
      const f = [];
      for (let i = 0; i < listData.length; i++) {
        if (fn(listData[i])) {
          f.push(listData[i]);
        }
      }
      return f;
    },
    async changeProvider(value) {
      let self = this;
      if (value == null || value == "") {
        self.DDModelShow = [];
        return "Required.";
      } else {
        if (value == "Google" || value == "Anthropic" || value == "Azure") {
          self.DDModelShow = self.listDDModel.filter(
            (e) => e.provider == value
          );
        } else {
          self.DDModelShow = self.listDDModel.filter(
            (e) => e.provider == value
          );
        }
        // self.LLmsModel.typeLLM = 0;
      }
    },
    clearLLM() {
      this.LLmsModel.model = null;
    },
    async changeModel(value) {
      let self = this;
      if (value == null || value == "" || value.split("")[0] == "|") {
        self.maxLengthChar = 0;
        self.LLmsModel.model = null;
        if (value.split("")[0] == "|") {
          self.$swal.fire({
            icon: "warning",
            title: self.$t("warning"),
            text: "Please select model",
            showConfirmButton: false,
            timer: 3000,
          });
        }
        return "required.";
      } else {
        let ddm = self.listDDModel.find((e) => e.modelName == value);
        self.totalTokens = ddm.maxToken;
        self.txtToImgChecker = ddm.modelType == "text_to_image";
        if (ddm) {
          if (value == "gpt-35-turbo") {
            self.maxLengthChar = 4000;
          } else if (value == "gpt-35-turbo-16k") {
            self.maxLengthChar = 8000;
          } else if (value == "gpt-4") {
            self.maxLengthChar = 6000;
          } else {
            self.maxLengthChar = null;
          }
          if (this.txtToImgChecker) {
            // self.LLmsModel.styleImage = ddm.styleImage;
            // self.LLmsModel.resFormatImage = ddm.resFormatImage;
            self.LLmsModel.quality = ddm.quality;
            self.LLmsModel.resolution = ddm.resolution;
            self.LLmsModel.resFormatImage = "url";
          } else {
            self.LLmsModel.styleImage = null;
            self.LLmsModel.resFormatImage = null;
            self.LLmsModel.quality = null;
            self.LLmsModel.resolution = null;
          }
          self.LLmsModel.APIVersion = ddm.apiVersion;
          self.LLmsModel.modelType = ddm.modelType;
          self.LLmsModel.jsonRequest = ddm.jsonRequest;
          self.showReasoningEffort = ddm.useReasoningEffort;
          self.LLmsModel.endPointURL = ddm.endPointURL;
          self.LLmsModel.apI_Key = ddm.apI_Key;
          // self.maxLengthChar = self.DDModel.find((e) => e.model == value).maxPrompt;
        } else {
          self.maxLengthChar = null;
        }

        if (ddm.useUploadFile) {
          self.showFileUpload = ddm.useUploadFile;
        } else {
          self.showFileUpload = false;
          self.LLmsModel.isAllowImage = false;
          self.LLmsModel.fileUploadLimit = null;
        }
      }
    },
    numericKey: function (evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();
      if (!/^\d*\.?\d*$/.test(expect) || parseFloat(expect) <= 0) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    showPromptTemplate() {
      let self = this;
      if (self.DDGroupPromptTemplate.length > 0) {
        self.showPromptTem = !self.showPromptTem;
      } else {
        self.showPromptTem = false;
      }
    },
    showAll() {
      let self = this;
      self.dialogShowAll = true;
    },
    forbiddenWordHandle(forbiddenWord) {
      if (!forbiddenWord) {
        return this.LLmsModel.forbiddenWord && this.LLmsModel.forbiddenWord.length
          ? this.LLmsModel.forbiddenWord
          : [""];
      }

      try {
        const parsedData = JSON.parse(forbiddenWord);
        return Array.isArray(parsedData) && parsedData.length ? parsedData : [""];
      } catch (error) {
        console.error("Failed to parse forbidden words", error);
        return [""];
      }
    },
    forbiddenWordSaveHandle(inputList) {
      if (!Array.isArray(inputList)) {
        return null;
      }

      const sanitizedList = inputList
        .map((element) => (element ?? "").trim())
        .filter((element) => element !== "");

      if (sanitizedList.length === 0) {
        return null;
      }

      return JSON.stringify(sanitizedList);
    },

  },
  async mounted() {
    let self = this;
    await self.GetAllDDModelManagement();
    if (!this.LLmsModel.reasoningEffort && this.reasonOptions.length > 0) {
      this.LLmsModel.reasoningEffort = this.reasonOptions[0].value;
    }
  }
};
</script>
<style scoped>
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
}

textarea {
  min-height: 800px !important;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

.icon {
  order: 0;
}

.header {
  font-weight: 700;
}

.publication-header-controls {
  display: inline-flex;
  align-items: center;
  gap: 14px;
}

.publication-header-wrapper {
  margin-left: auto;
  display: flex;
  align-items: center;
}

.publication-status-chip {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  width: 100px;
  height: 32px;
  box-shadow: none !important;
}

.publication-label {
  font-size: 14px;
  font-weight: 600;
}

.publication-toggle {
  margin: 0 4px;
}

.publication-toggle :deep(.v-switch__track) {
  transform: scale(0.8);
  width: 40px;
  height: 28px;
  border-radius: 999px;
  border: 2px solid transparent;
  background-color: transparent;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.publication-toggle :deep(.v-switch__thumb) {
  width: 20px;
  height: 20px;
  box-shadow: none;
  border: 2px solid transparent;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.publication-toggle--active :deep(.v-switch__track) {
  background-color: #ffffff !important;
  border-color: #d32f2f;
}

.publication-toggle--active :deep(.v-switch__thumb) {
  background-color: #d32f2f !important;
  border-color: #d32f2f;
  transform: translateX(-0.5px);
}

.publication-toggle--inactive :deep(.v-switch__track) {
  background-color: #bdbdbd !important;
  border-color: #bdbdbd;
}

.publication-toggle--inactive :deep(.v-switch__thumb) {
  background-color: #ffffff !important;
  border-color: #bdbdbd;
  width: 30px;
  height: 30px;
}

.publication-version {
  font-size: 14px;
  font-weight: 600;
  color: #d84315;
  letter-spacing: 0.8px;
  text-transform: uppercase;
}

.v-text-field :deep(label) {
  font-size: 0.9375rem;
}

.v-expansion-panel-header {
  padding: 0;
  background-color: transparent !important;
}

:deep(.expan-Pannel) .v-expansion-panel--active>.v-expansion-panel-header {
  min-height: 48px;
  background-color: transparent !important;
}

.forbidden-btn {
  opacity: 0;
}

.forbidden-btn:hover {
  opacity: 100%;
}

.deep-purple.accent-4 {
  background-color: #1976d2 !important;
  border-color: #1976d2 !important;
}

.image-settings-container {
  border-radius: 4px;
  padding: 16px;
}

.info-icon {
  position: absolute;
  right: -6px;
  top: 0;
}

.image-select {
  width: auto;
}

.info-icon:hover {
  color: #1976d2;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.v-divider {
  border-color: rgba(0, 0, 0, 0.12);
}

.v-col {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
}

.v-card {
  /* background-color: transparent !important; */
  box-shadow: none !important;
  border-radius: 8px !important;
  border: none;
}

.v-tab {
  text-transform: none;
  font-weight: 500;
}

.v-text-field.v-text-field--enclosed .v-text-field__details,
.v-select.v-select--enclosed .v-select__details {
  margin-bottom: 0;
}

.model-type-toggle {
  width: 100% !important;
  border-radius: 12px;
  gap: 8px;
}

.model-type-btn {
  flex: 1;
  height: 36px !important;
  text-transform: none;
  font-weight: 600 !important;
  letter-spacing: 0.5px;
  min-width: 120px !important;
  border-radius: 12px !important;
}
.model-type-btn {
  
}

.model-type-card {
  border-radius: 12px;
  border: none !important;
  transition: background 1s ease;
}

.model-input-group {
  align-items: center;
}

.model-input-col {
  display: flex;
  flex-direction: column;
}

.model-input-control :deep(.v-field) {
  border-radius: 12px !important;
  min-height: 48px;
  /* padding-inline: 12px; */
  box-shadow: none;
}

.model-input-control :deep(.v-input__details) {
  display: none;
}

.model-input-control :deep(.v-field__input) {
  padding-top: 13px;
}


.custom-vertical-divider {
  width: 1px;
  border-radius: 999px;
  background: #00000039;
  min-height: 60px;
}

@media (max-width: 960px) {
  .vertical-divider-wrapper {
    display: none !important;
  }
}

.model-input-control :deep(.v-field__outline) {
  border-radius: 12px;
  --v-field-border-opacity: 0.4;
}

.model-input-control :deep(.v-field__outline--focused) {
  --v-field-border-opacity: 1;
}

@media (max-width: 960px) {
  .model-input-row {
    gap: 12px;
  }

  .model-input-control :deep(.v-field) {
    min-height: 44px;
  }
}

/* Bot button styles */
.v-btn-toggle .v-btn--active {
  background: linear-gradient(90deg, #C32E0E 0%, #F67760 100%) !important;
  box-shadow: none !important;
  border: none !important;
  color: white !important;
}

/* Make expansion panel background transparent */
:deep(.v-expansion-panels) {
  background-color: transparent !important;
}

/* Make individual expansion panel background transparent */
:deep(.v-expansion-panel) {
  background-color: transparent !important;
}

/* Make expansion panel content background transparent */
:deep(.v-expansion-panel-content) {
  background-color: transparent !important;
}

/* Make expansion panel header background transparent */
:deep(.v-expansion-panel-header) {
  background-color: transparent !important;
}

/* Optional: Remove box-shadow if present */
:deep(.v-expansion-panels) {
  box-shadow: none !important;
}

:deep(.v-expansion-panel)::before {
  box-shadow: none !important;
}

.model-chip {
  padding: 0 50px;
  height: 40px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.5px;
  text-transform: none;
  transition: all 0.5s ease;
}

.model-chip:hover {
  opacity: 1;
}

.model-id {
  color: black;
  margin-left: 4px;
  font-weight: 500;
}

/* Optional: Add a subtle animation when the chip appears */
.model-chip {
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.position-relative {
  position: relative;
}

.version-badge {
  z-index: 1;
}

.version-text {
  margin-left: -4px;
  font-size: 11px;
  font-weight: 500;
  color: #616161;
  letter-spacing: 0.4px;
}

.modern-panels {
  background: transparent;
  border-radius: 20px;
  padding: 12px;
}

.modern-panels :deep(.v-expansion-panel) {
  background-color: #ffffff !important;
  border-radius: 16px !important;
  margin-bottom: 16px;
  overflow: hidden;
  transition: border-color 0.25s ease, box-shadow 0.25s ease, transform 0.25s ease;
}

.modern-panels :deep(.v-expansion-panel:not(:last-of-type)) {
  margin-bottom: 18px;
}

.modern-panels :deep(.v-expansion-panel--active) {
  border-color: #C9C9C9;
  border: 1px solid #e5e7eb;
  transform: translateY(-2px);
}

.modern-panels :deep(.v-expansion-panel-title) {
  min-height: auto;
  padding: 18px 24px;
  background: linear-gradient(135deg, #FFF2F2 0%, #FFDED8 100%);
  transition: background-color 0.2s ease, padding 0.2s ease;
}

/* .modern-panels :deep(.v-expansion-panel-title:hover) {
  background: linear-gradient(135deg, #FFF2F2 0%, #FFDED8 100%);
} */

.modern-panels :deep(.v-expansion-panel-title--active) {
  background: transparent;
}

.modern-panels :deep(.v-expansion-panel-text) {
  background: #ffffff;
  padding: 20px 24px 24px;
}

.modern-panels :deep(.v-expansion-panel-title__overlay) {
  background-color: transparent !important;
}

.modern-panels :deep(.v-expansion-panel-title__icon) {
  margin-left: auto;
  color: #9ca3af;
  transition: transform 0.25s ease, color 0.25s ease;
}

.modern-panels :deep(.v-expansion-panel-title--active .v-expansion-panel-title__icon) {
  color: #ef4444;
  transform: rotate(180deg);
}

.panel-header {
  width: 100%;
  column-gap: 12px;
  color: #1f2937;
}

.panel-header .header {
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 0.01em;
}

.workflow-header {
  justify-content: flex-start;
  column-gap: 16px;
  row-gap: 4px;
}

.workflow-header__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
}

.workflow-header__text {
  display: flex;
  flex-direction: column;
}

.workflow-header__text .header {
  font-size: 17px;
}

.workflow-header__subtitle {
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 4px;
}

.workflow-header__title {
  color: #1f2937;
}

@media (max-width: 600px) {
  .workflow-header {
    align-items: flex-start;
  }

  .workflow-header__icon {
    width: 40px;
    height: 40px;
  }

  .workflow-header__subtitle {
    font-size: 12px;
  }
}


.panel-content {
  padding: 22px 0;
  background: linear-gradient(180deg, rgba(249, 250, 251, 0.4) 0%, rgba(255, 255, 255, 0.95) 40%, rgba(255, 255, 255, 1) 100%);
  border-top: 1px solid #e5e7eb;
}

/* อนิเมชัน */
.transition-swing {
  transition-duration: 0.3s;
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.prompt-template-container {
  padding: 0.5rem 0;
}

.prompt-editor-card {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  transition: all 0.2s ease;
}

.prompt-editor-card:hover {
  border-color: rgba(25, 118, 210, 0.5);
  box-shadow: 0 1px 3px rgba(227, 6, 6, 0.05);
}

.prompt-textarea {
  font-family: 'Roboto Mono', monospace;
  line-height: 1.5;
  border: none !important;
  box-shadow: none !important;
  padding: 12px !important;
  font-size: 14px;
  min-height: 300px !important;
}


.prompt-editor-card {
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
  box-shadow: none !important;
  transition: all 0.2s ease;
  overflow: hidden;
}

.prompt-editor-card:hover {
  border-color: rgba(25, 118, 210, 0.5) !important;
}

.prompt-templates-card {
  border-radius: 8px;
  background-color: #FFF2F2;
  transition: all 0.3s ease;
}

.template-list-item {
  border-radius: 4px;
  margin-bottom: 2px;
  transition: all 0.2s ease;
}

.template-list-item:hover {
  background-color: rgba(25, 118, 210, 0.04);
}

.prompt-template-list {
  max-height: 500px;
  overflow-y: auto;
  background-color: transparent;
}

.template-list-all {
  max-height: 400px;
  overflow-y: auto;
}

.v-divider {
  border-color: rgba(0, 0, 0, 0.753) !important;
}

.v-card {
  transition: all 0.2s ease;
}

.rounded-lg {
  border-radius: 8px !important;
}

.v-card__title {
  font-size: 1rem !important;
  padding: 12px 16px !important;
}

.v-card__text {
  padding: 12px 16px !important;
}

.h-100 {
  height: 100%;
}

/* Fix position of tooltips */
:deep(.v-tooltip__content) {
  background-color: rgba(33, 33, 33, 0.95);
  border-radius: 4px;
  font-size: 0.75rem;
  padding: 5px 10px;
}

.options-section {
  padding: 16px 20px;
}

.option-card {
  padding: 5px 16px;
  border-radius: 10px !important;
  background-color: #EDEDED;
  height: 50px !important;
  border: 1px solid transparent;
  transition: all 0.2s cubic-bezier(0.25, 0.8, 0.25, 1);
  position: relative;
  overflow: hidden;
}

.on-hover {
  border-color: rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.08) !important;
}

.option-header {
  max-width: calc(100% - 50px);
}
/* Card title styling */
.v-card__title.subtitle-1 {
  font-size: 16px !important;
  padding: 14px 20px !important;
  background-color: transparent;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}

.additional-content {
  padding-bottom: 8px;
  min-height: 58px;
}

.upload-limit-field,
.timezone-field {
  min-height: 58px;
}

.status-switch-container {
  border-radius: 8px;
  background-color: #f5f5f5;
  transition: all 0.3s ease;
}

.status-switch {
  transform: scale(1.2);
}

.status-label {
  min-width: 150px;
}

.status-container {
  background-color: #f9f9f9;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.status-toggle {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  overflow: hidden;
}

.toggle-btn {
  text-transform: none;
  letter-spacing: 0.5px;
  min-width: 90px;
}

.active-btn.draft-btn {
  background-color: rgba(255, 152, 0, 0.1) !important;
  color: #ff9800 !important;
  font-weight: 500;
}

.active-btn.publish-btn {
  background-color: rgba(76, 175, 80, 0.1) !important;
  color: #4CAF50 !important;
  font-weight: 500;
}

.enhanced-select :deep(.v-field) {
  border-radius: 8px !important;
  transition: all 0.2s ease;
}

.enhanced-select :deep(.v-field:hover) {
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.15);
}

.enhanced-select :deep(.v-field--focused) {
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.2);
}

/* Selection Display */
.timezone-selection {
  width: 100%;
  padding: 2px 0;
}

.timezone-code {
  font-size: 10px !important;
  height: 18px !important;
  font-weight: 500;
  letter-spacing: 0.5px;
}

/* Dropdown Items */
.timezone-item {
  padding: 12px 16px !important;
  border-radius: 6px;
  margin: 2px 8px;
  transition: all 0.2s ease;
}

.timezone-item:hover {
  background-color: rgba(25, 118, 210, 0.04) !important;
  transform: translateX(2px);
}

.timezone-item-content {
  width: 100%;
}

.timezone-country {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
  line-height: 1.2;
}

.timezone-details {
  gap: 8px;
}

/* Avatar styling */
.timezone-item :deep(.v-avatar) {
  margin-right: 12px;
}

/* Dropdown styling */
.enhanced-select :deep(.v-overlay__content) {
  border-radius: 12px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
  border: 1px solid rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.enhanced-select :deep(.v-list) {
  padding: 8px 0 !important;
  background-color: white;
}

/* Icon animations */
.timezone-item :deep(.v-icon) {
  transition: all 0.2s ease;
}

.timezone-item:hover :deep(.v-icon) {
  transform: scale(1.1);
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .timezone-selection {
    flex-direction: column;
    align-items: flex-start !important;
  }

  .timezone-code {
    margin-left: 0 !important;
    margin-top: 4px !important;
  }
}

.reasoning-chip {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-align: center !important;
  min-width: 120px;
  height: 28px !important;
}

.reasoning-chip :deep(.v-chip__content) {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  text-align: center !important;
  font-weight: 500;
}

.reasoning-chip :deep(.v-chip__underlay) {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* สำหรับ Vuetify 3 */
.reasoning-chip :deep(.v-chip__content) {
  padding: 0 8px !important;
  line-height: 2 !important;
}

/* Image Generation Settings Styling */
.image-settings-card {
  border-radius: 16px !important;
  overflow: hidden;
  border: 1px solid rgba(25, 118, 210, 0.2) !important;
  transition: all 0.1s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.image-header {
  background: linear-gradient(135deg, rgba(215, 235, 255, 0.185) 10%, rgba(25, 118, 210, 0.226) 100%);
  border-bottom: 1px solid rgba(25, 118, 210, 0.1);
}

.setting-group {
  position: relative;
  padding: 16px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
  height: 100%;
}

.setting-group:hover {
  background: rgba(255, 255, 255, 0.9);
  border-color: rgba(25, 118, 210, 0.3);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.setting-label {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
  margin-bottom: 8px;
}

/* Enhanced Select Styling */
.style-select :deep(.v-field) {
  border-radius: 8px !important;
  transition: all 0.2s ease;
  background: white;
}

.style-select :deep(.v-field:hover) {
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.15);
  border-color: rgba(11, 133, 255, 0.829) !important;
}

.style-select :deep(.v-field--focused) {
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.2);
  border-color: rgba(25, 118, 210, 0.8) !important;
}

/* Style Items */
.style-item {
  border-radius: 8px;
  margin: 4px 8px;
  transition: all 0.2s ease;
}

.style-item:hover {
  background: linear-gradient(135deg, rgba(220, 237, 255, 0.767) 0%, rgba(138, 197, 255, 0.568) 100%);
  transform: translateX(3px);
}

/* Quality and Resolution Fields */
.quality-field :deep(.v-field),
.resolution-field :deep(.v-field) {
  border-radius: 8px !important;
  background: rgba(245, 245, 245, 0.8) !important;
  /* transition: all 0.2s ease; */
}

.quality-field :deep(.v-field:hover),
.resolution-field :deep(.v-field:hover) {
  background: rgba(240, 240, 240, 0.9) !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

/* Animation Improvements */
.fade-enter-active,
.fade-leave-active {
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-20px) scale(0.95);
}

/* Responsive Design */
@media (max-width: 960px) {
  .setting-group {
    margin-bottom: 16px;
  }

  .image-header {
    padding: 16px !important;
  }

  .image-header h3 {
    font-size: 1.1rem !important;
  }
}

/* Dropdown Enhancements */
.style-select :deep(.v-overlay__content) {
  border-radius: 12px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15) !important;
  border: 1px solid rgba(25, 118, 210, 0.1);
  overflow: hidden;
}

.style-select :deep(.v-list) {
  padding: 8px !important;
  background: rgba(255, 255, 255, 0.95);
}

/* Chip Enhancements */
.v-chip.v-chip--size-x-small {
  font-size: 10px !important;
  height: 20px !important;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.v-chip.v-chip--size-small {
  font-size: 11px !important;
  height: 24px !important;
  font-weight: 500;
  letter-spacing: 0.5px;
}

/* Loading State */
.image-settings-container.loading {
  opacity: 0.7;
  pointer-events: none;
}

.image-settings-container.loading::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(2px);
  z-index: 1;
}

.status-wrapper {
  padding: 20px;
}

.status-header {
  margin-bottom: 4px;
}

.status-display-section {
  padding: 8px 0;
}

.status-badge-container {
  margin-bottom: 8px;
}

.status-description {
  display: flex;
  align-items: center;
  opacity: 0.8;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
}


.status-switch {
  transform: scale(1.1);
}

.switch-label {
  font-size: 12px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.6);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-alert {
  border-radius: 12px !important;
  border: none !important;
  padding: 12px 16px !important;
}

.alert-content {
  line-height: 1.3;
}

/* Switch Styling */
.status-switch :deep(.v-switch__track) {
  width: 48px !important;
  height: 24px !important;
  border-radius: 12px !important;
}

.status-switch :deep(.v-switch__thumb) {
  width: 20px !important;
  height: 20px !important;
  border-radius: 10px !important;
}


/* Avatar animations */
.status-wrapper .v-avatar {
  transition: all 0.3s ease;
}


/* แบบเต็มหน้าจอ */
.publication-status-card-full {
  border-radius: 16px !important;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 1) 100%);
}

.status-wrapper-full {
  padding: 24px;
}

.status-wrapper-full .v-icon {
  transition: all 0.2s ease;
}

.status-header-full {
  margin-bottom: 8px;
}

.status-chip-large {
  font-weight: 600 !important;
  font-size: 14px !important;
  padding: 0 20px !important;
  height: 40px !important;
  border-radius: 20px !important;
  display: flex;
  justify-content: center;
  min-width: 150px;
}

.status-content-section {
  margin: 0 -8px;
}

.status-info-card,
.status-control-card {
  background: rgba(255, 255, 255, 0.7);
  border-radius: 12px;
  padding: 16px;
  height: 100%;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.status-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.model-stats .stat-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.stat-label {
  color: rgba(0, 0, 0, 0.6);
  font-weight: 500;
}

.stat-value {
  font-weight: 600;
  color: rgba(0, 0, 0, 0.87);
}

.toggle-container {
  display: flex;
  background: rgba(25, 118, 210, 0.05);
  border-radius: 12px;
  padding: 16px;
  text-align: center;
  justify-content: center;
  background: linear-gradient(135deg,
      rgba(89, 150, 211, 0.03) 0%,
      rgba(53, 134, 216, 0.08) 100%);
}


.status-switch-large {
  transform: scale(1.3);
}

.status-switch-active :deep(.v-switch__track) {
  background-color: rgba(76, 175, 79, 0.4) !important;
}

.status-switch-active :deep(.v-switch__thumb) {
  background-color: #4CAF50 !important;
  box-shadow: 0px 0px 4px rgba(47, 177, 7, 0.705);
}

.status-switch-inactive :deep(.v-switch__track) {
  box-shadow: 2px 3px 6px rgba(90, 60, 45, 0.582);
  background-color: rgba(255, 153, 0, 0.3) !important;
  border: 1px solid rgba(253, 140, 11, 0.15) !important;
}

.status-switch-inactive :deep(.v-switch__thumb) {
  background-color: #FF9800 !important;
}

.switch-label-container {
  text-align: center;
  min-width: 100px;
  display: flex;
  flex-direction: column;
}

.switch-label-large {
  font-size: 16px;
  font-weight: 600;
  display: block;
  transition: color 0.3s ease;
}

.status-control-card .switch-label-large {
  color: rgba(0, 0, 0, 0.87);
}

.switch-sublabel {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  display: block;
  margin-top: 4px;
}

.publish-card {
  background: linear-gradient(135deg, rgba(var(--v-theme-primary), 0.03) 0%, rgba(var(--v-theme-secondary), 0.01) 100%);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.publish-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(var(--v-theme-primary), 0.05), transparent);
  transition: left 0.6s ease;
}
.no-data-message-card {
  padding: 18px 22px;
  border-radius: 16px !important;
  background: linear-gradient(180deg, #ffffff 0%, #fff6f4 100%);
  border: 1px solid rgba(195, 46, 14, 0.2) !important;
  box-shadow: 0 4px 15px rgba(195, 46, 14, 0.08);
}
.no-data-message-content {
  max-width: calc(100% - 140px);
}
.no-data-message-title {
  display: block;
  font-size: 15px;
  font-weight: 600;
  color: #c32e0e;
  margin-bottom: 6px;
}
.no-data-message-preview {
  font-size: 13px;
  color: rgba(55, 65, 81, 0.85);
  line-height: 1.5;
  max-height: 60px;
  overflow: hidden;
}
.no-data-message-button {
  text-transform: none;
  border: 1px solid #c32e0e !important;
  border-radius: 12px !important;
  font-weight: 600;
  letter-spacing: 0.5px;
  background: transparent !important;
  height: 50px !important;
  color: #c32e0e !important;
  padding: 0 26px !important;
}
.no-data-dialog-card {
  border-radius: 18px !important;
  overflow: hidden;
  background: linear-gradient(180deg, #ffffff 0%, #fff8f6 100%);
}
.no-data-dialog-card :deep(.v-card-title) {
  font-weight: 600;
  letter-spacing: 0.3px;
}
.no-data-dialog-card :deep(.v-card-text .v-field) {
  border-radius: 12px !important;
}
.no-data-dialog-card :deep(.v-card-actions) {
  gap: 8px;
}

.memory-section-wrapper {
  margin-bottom: 0px;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.memory-card {
  border-radius: 18px !important;
  background: #FFF2F2;
  height: 160px;
}

.memory-card__body {
  display: flex;
  column-gap: 24px;
  row-gap: 18px;
  align-items: stretch;
}

.memory-card__short,
.memory-card__long {
  display: flex;
  flex-direction: column;
}

.memory-section-header {
  display: flex;
  align-items: center;
  column-gap: 14px;
  margin-bottom: 18px;
}

.memory-section-header.justify-space-between {
  align-items: center;
}

.memory-icon {
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.memory-title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 4px;
}

.memory-subtitle {
  font-size: 12px;
  color: rgba(55, 65, 81, 0.65);
}

.memory-status {
  font-size: 13px;
  color: rgba(55, 65, 81, 0.75);
}

.memory-card :deep(.v-field) {
  border-radius: 12px !important;
  background-color: #ffffff !important;
  border: 1px solid rgba(255, 255, 255, 0.9) !important;
  box-shadow: 0 4px 10px rgba(195, 46, 14, 0.05);
}

.memory-card :deep(.v-field:hover) {
  box-shadow: 0 6px 14px rgba(195, 46, 14, 0.08);
}

.memory-card__divider {
  align-self: stretch;
  margin: 0 8px;
  height: 100%;
  border: 1px solid rgba(229, 231, 235, 0.8);
}

.memory-input-row {
  margin-top: -15px;
  padding-left: 10px;
}

.col-label-input {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
}

.multi-turn-section {
  margin-top: 18px;
  border-radius: 16px;
  padding: 18px 0px;
}

.multi-turn-toggle {
  display: flex;
  align-items: center;
  margin-top: 25px;
}

.multi-turn-label {
  font-weight: 600;
  color: #1f2937;
  cursor: pointer;
  font-size: 14px;
}

.forbidden-container {
  border-radius: 16px;
  padding: 18px;
  background: #ffffff;
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  row-gap: 14px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.04);
}

.forbidden-summary {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.forbidden-summary__info {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.forbidden-summary__title {
  font-weight: 600;
  font-size: 14px;
  color: #111827;
  margin: 0;
}

.forbidden-summary__subtitle {
  margin: 2px 0 0;
  font-size: 13px;
  color: rgba(55, 65, 81, 0.7);
}

.forbidden-summary__count {
  font-size: 13px;
  color: rgba(17, 24, 39, 0.75);
  background: rgba(195, 46, 14, 0.08);
  border-radius: 999px;
  padding: 6px 14px;
  font-weight: 600;
  align-self: center;
}

.forbidden-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(55, 65, 81, 0.65);
  font-size: 13px;
  background: rgba(248, 250, 252, 0.85);
  border-radius: 12px;
  padding: 12px;
  border: 1px dashed rgba(148, 163, 184, 0.6);
}

.forbidden-list {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}

.forbidden-item {
  display: flex;
  align-items: center;
  column-gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid rgba(229, 231, 235, 0.8);
}

.forbidden-item:last-child {
  border-bottom: none;
}

.forbidden-index {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(195, 46, 14, 0.12);
  font-weight: 600;
  color: #c32e0e;
}

.forbidden-input {
  flex: 1;
}

.forbidden-input :deep(.v-field) {
  border-radius: 10px !important;
  background: rgba(248, 250, 252, 0.8) !important;
}

.forbidden-input :deep(.v-field:hover) {
  box-shadow: inset 0 0 0 1px rgba(195, 46, 14, 0.25);
}

.forbidden-delete {
  min-width: 36px !important;
  width: 36px !important;
  height: 36px !important;
  border-radius: 12px !important;
}

.forbidden-footer {
  padding-top: 12px;
  display: flex;
  justify-content: flex-start;
}

.forbidden-add-btn {
  border-radius: 10px !important;
  font-weight: 600;
  text-transform: none;
  color: #c32e0e !important;
  width: 120px !important;
}

.forbidden-fade-enter-active,
.forbidden-fade-leave-active {
  transition: all 0.18s ease;
}

.forbidden-fade-enter-from,
.forbidden-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

.multi-turn-section :deep(.v-field) {
  border-radius: 12px !important;
}

@media (max-width: 960px) {
  .memory-card__body {
    flex-direction: column;
  }

  .memory-card__divider {
    display: none;
  }

  .forbidden-item {
    flex-direction: column;
    align-items: stretch;
    row-gap: 10px;
    padding: 14px 0;
  }

  .forbidden-index {
    width: 32px;
    height: 32px;
    align-self: flex-start;
  }

  .forbidden-summary {
    flex-direction: column;
    gap: 12px;
  }

  .forbidden-summary__count {
    align-self: flex-start;
  }
}

@media (max-width: 600px) {
  .memory-card {
    padding: 20px 18px;
  }

  .multi-turn-section {
    padding: 16px;
  }

  .forbidden-container {
    padding: 14px;
  }
}


.publish-card:hover::before {
  left: 100%;
}

/* Flow Selection Card Styling */
.flow-selection-card {
  border-radius: 16px !important;
  border: 1px solid rgba(25, 118, 210, 0.12) !important;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 1) 100%);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.flow-selection-card:hover {
  border-color: rgba(25, 118, 210, 0.3) !important;
  box-shadow: 0 8px 24px rgba(25, 118, 210, 0.08) !important;
}

.flow-card-header {
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.03) 0%, rgba(25, 118, 210, 0.08) 100%);
  border-bottom: 1px solid rgba(25, 118, 210, 0.1);
}

.flow-selector-wrapper {
  position: relative;
  padding: 16px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.flow-selector-wrapper:hover {
  background: rgba(255, 255, 255, 0.9);
  /* border-color: rgba(25, 118, 210, 0.3); */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

/* Enhanced Flow Select */
.flow-select-enhanced :deep(.v-field) {
  border-radius: 12px !important;
  transition: all 0.3s ease;
  background: white;
  height: 48px;
}

.autocomplete-field-c :deep(.v-field__field) {
  padding-top: 3px;
}


/* Flow Selection Display */
.flow-selection-display {
  padding: 4px 0;
  width: 100%;
}

/* Flow Dropdown Items */
.flow-list-item {
  border-radius: 8px;
  margin: 4px 8px;
  transition: all 0.2s ease;
  padding: 12px 16px !important;
}

.flow-list-item:hover {
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.04) 0%, rgba(25, 118, 210, 0.08) 100%);
  transform: translateX(4px);
}

/* Flow Status Display */
.flow-status-display {
  position: relative;
  padding: 16px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  height: 100%;
}

.flow-status-display:hover {
  background: rgba(255, 255, 255, 0.9);
  border-color: rgba(25, 118, 210, 0.2);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.flow-status-content {
  padding: 8px 0;
}

.flow-connected,
.flow-disconnected {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

/* Enhanced Info Button */
.info-btn-enhanced {
  position: relative;
  transition: all 0.2s ease;
}

.info-btn-enhanced:hover {
  background-color: rgba(25, 118, 210, 0.08) !important;
  transform: scale(1.1);
}

/* Dropdown Enhancements */
.flow-select-enhanced :deep(.v-overlay__content) {
  border-radius: 16px !important;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15) !important;
  border: 1px solid rgba(25, 118, 210, 0.1);
  overflow: hidden;
}

.flow-select-enhanced :deep(.v-list) {
  padding: 12px !important;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
}

/* Chip Animations */
.flow-connected .v-chip,
.flow-disconnected .v-chip {
  animation: chipPulse 2s ease-in-out infinite;
}

@keyframes chipPulse {

  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.02);
  }
}

/* Responsive Design */
@media (max-width: 960px) {

  .flow-selector-wrapper,
  .flow-status-display {
    margin-bottom: 16px;
  }

  .flow-card-header {
    padding: 16px !important;
  }

  .flow-card-header .text-h6 {
    font-size: 1.1rem !important;
  }
}

/* Icon Animations */
.flow-selection-card .v-icon {
  transition: all 0.2s ease;
}

.flow-selection-card:hover .v-icon {
  transform: scale(1.05);
}

.model-type-toggle-container {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.12);
  height: 48px;
  border-radius: 14px;
  padding: 8px;
}

.description-field :deep(.v-field) {
  border-radius: 12px !important;
  min-height: 50px;
}

.description-field :deep(.v-field__input) {
  padding-top: 13px !important;
}

.rounded-input :deep(.v-field) {
  border-radius: 12px !important;
  min-height: 50px;
}
.input--enabled :deep(.v-field) {
  background-color: #ffffff !important;
}
.input--disabled :deep(.v-field) {
  background-color: #ffffff !important;
  color: rgba(55, 65, 81, 0.6) !important;
}
.input--disabled :deep(.v-field__input),
.input--disabled :deep(.v-select__selection-text),
.input--disabled :deep(input) {
  color: rgba(55, 65, 81, 0.6) !important;
}
.padding-input :deep(.v-field) {
  padding-top: 5px !important;
}
.padding-input2 :deep(.v-field) {
  padding-top: 4px !important;
}

.dialog-close-btn {
  border: 1px solid #C32E0E !important; /* red outline */
  color: #C32E0E !important;
  background: transparent !important;
  border-radius: 12px !important;
  padding: 6px 18px !important;
  text-transform: none !important;
  font-weight: 500 !important;
  height: 40px !important;
  width: 100px !important;
  box-shadow: none !important;
}
.dialog-close-btn .v-icon {
  margin-right: 6px;
}
.dialog-save-btn {
  background: linear-gradient(90deg, #C32E0E 0%, #F67760 100%) !important; /* orange gradient */
  color: #fff !important;
  border-radius: 12px !important;
  padding: 6px 18px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  height: 40px !important;
  width: 120px !important;
  box-shadow: none !important;
}
.dialog-save-btn-green {
  background: #04B439!important; /* green gradient */
  color: #fff !important;
  border-radius: 12px !important;
  padding: 6px 18px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  height: 40px !important;
  width: 120px !important;
  box-shadow: none !important;
}
.dialog-save-btn .v-icon {
  margin-right: 6px;
}
.flow-not-selected{
  background: #C1C3CB !important;
  color: white !important;
}
.flow-selected{
  background: rgba(42, 191, 86, 0.10) !important;
  color: #2ABF56 !important;
}
.chipdiv {
  margin-right: 15px;
  gap: 10px;
}
.chipspan{
  color: #646464;
  font-family: var(--Poppins-Font, Poppins);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
</style>
